export const naicsDictionary = {
    "111110": {
      value: { code: "111110", label: "Soybean Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111120": {
      value: { code: "111120", label: "Oilseed (except Soybean) Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111130": {
      value: { code: "111130", label: "Dry Pea and Bean Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111140": {
      value: { code: "111140", label: "Wheat Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111150": {
      value: { code: "111150", label: "Corn Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111160": {
      value: { code: "111160", label: "Rice Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111191": {
      value: { code: "111191", label: "Oilseed and Grain Combination Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111199": {
      value: { code: "111199", label: "All Other Grain Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Oilseed and Grain Farming"
    },
    "111211": {
      value: { code: "111211", label: "Potato Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Vegetable and Melon Farming"
    },
    "111219": {
      value: {
        code: "111219",
        label: "Other Vegetable (except Potato) and Melon Farming"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Vegetable and Melon Farming"
    },
    "111310": {
      value: { code: "111310", label: "Orange Groves" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111320": {
      value: { code: "111320", label: "Citrus (except Orange) Groves" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111331": {
      value: { code: "111331", label: "Apple Orchards" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111332": {
      value: { code: "111332", label: "Grape Vineyards" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111333": {
      value: { code: "111333", label: "Strawberry Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111334": {
      value: { code: "111334", label: "Berry (except Strawberry) Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111335": {
      value: { code: "111335", label: "Tree Nut Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111336": {
      value: { code: "111336", label: "Fruit and Tree Nut Combination Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111339": {
      value: { code: "111339", label: "Other Noncitrus Fruit Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fruit and Tree Nut Farming"
    },
    "111411": {
      value: { code: "111411", label: "Mushroom Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Greenhouse, Nursery, and Floriculture Production"
    },
    "111419": {
      value: { code: "111419", label: "Other Food Crops Grown Under Cover" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Greenhouse, Nursery, and Floriculture Production"
    },
    "111421": {
      value: { code: "111421", label: "Nursery and Tree Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Greenhouse, Nursery, and Floriculture Production"
    },
    "111422": {
      value: { code: "111422", label: "Floriculture Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Greenhouse, Nursery, and Floriculture Production"
    },
    "111910": {
      value: { code: "111910", label: "Tobacco Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111920": {
      value: { code: "111920", label: "Cotton Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111930": {
      value: { code: "111930", label: "Sugarcane Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111940": {
      value: { code: "111940", label: "Hay Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111991": {
      value: { code: "111991", label: "Sugar Beet Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111992": {
      value: { code: "111992", label: "Peanut Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "111998": {
      value: { code: "111998", label: "All Other Miscellaneous Crop Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Crop Farming"
    },
    "112111": {
      value: { code: "112111", label: "Beef Cattle Ranching and Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Cattle Ranching and Farming"
    },
    "112112": {
      value: { code: "112112", label: "Cattle Feedlots" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Cattle Ranching and Farming"
    },
    "112120": {
      value: { code: "112120", label: "Dairy Cattle and Milk Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Cattle Ranching and Farming"
    },
    "112130": {
      value: {
        code: "112130",
        label: "Dual-Purpose Cattle Ranching and Farming"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Cattle Ranching and Farming"
    },
    "112210": {
      value: { code: "112210", label: "Hog and Pig Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Hog and Pig Farming"
    },
    "112310": {
      value: { code: "112310", label: "Chicken Egg Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Poultry and Egg Production"
    },
    "112320": {
      value: {
        code: "112320",
        label: "Broilers and Other Meat Type Chicken Production"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Poultry and Egg Production"
    },
    "112330": {
      value: { code: "112330", label: "Turkey Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Poultry and Egg Production"
    },
    "112340": {
      value: { code: "112340", label: "Poultry Hatcheries" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Poultry and Egg Production"
    },
    "112390": {
      value: { code: "112390", label: "Other Poultry Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Poultry and Egg Production"
    },
    "112410": {
      value: { code: "112410", label: "Sheep Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Sheep and Goat Farming"
    },
    "112420": {
      value: { code: "112420", label: "Goat Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Sheep and Goat Farming"
    },
    "112511": {
      value: { code: "112511", label: "Finfish Farming and Fish Hatcheries" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Aquaculture"
    },
    "112512": {
      value: { code: "112512", label: "Shellfish Farming" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Aquaculture"
    },
    "112519": {
      value: { code: "112519", label: "Other Aquaculture" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Aquaculture"
    },
    "112910": {
      value: { code: "112910", label: "Apiculture" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Animal Production"
    },
    "112920": {
      value: { code: "112920", label: "Horses and Other Equine Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Animal Production"
    },
    "112930": {
      value: {
        code: "112930",
        label: "Fur-Bearing Animal and Rabbit Production"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Animal Production"
    },
    "112990": {
      value: { code: "112990", label: "All Other Animal Production" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Other Animal Production"
    },
    "113110": {
      value: { code: "113110", label: "Timber Tract Operations" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Timber Tract Operations"
    },
    "113210": {
      value: {
        code: "113210",
        label: "Forest Nurseries and Gathering of Forest Products"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Forest Nurseries and Gathering of Forest Products"
    },
    "113310": {
      value: { code: "113310", label: "Logging" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Logging"
    },
    "114111": {
      value: { code: "114111", label: "Finfish Fishing" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fishing"
    },
    "114112": {
      value: { code: "114112", label: "Shellfish Fishing" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fishing"
    },
    "114119": {
      value: { code: "114119", label: "Other Marine Fishing" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Fishing"
    },
    "114210": {
      value: { code: "114210", label: "Hunting and Trapping" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Hunting and Trapping"
    },
    "115111": {
      value: { code: "115111", label: "Cotton Ginning" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115112": {
      value: {
        code: "115112",
        label: "Soil Preparation, Planting, and Cultivating"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115113": {
      value: { code: "115113", label: "Crop Harvesting, Primarily by Machine" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115114": {
      value: {
        code: "115114",
        label: "Postharvest Crop Activities (except Cotton Ginning)"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115115": {
      value: {
        code: "115115",
        label: "Farm Labor Contractors and Crew Leaders"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115116": {
      value: { code: "115116", label: "Farm Management Services" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Crop Production"
    },
    "115210": {
      value: {
        code: "115210",
        label: "Support Activities for Animal Production"
      },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Animal Production"
    },
    "115310": {
      value: { code: "115310", label: "Support Activities for Forestry" },
      industry: "Agriculture, Forestry, Fishing and Hunting",
      subcategory: "Support Activities for Forestry"
    },
    "211120": {
      value: { code: "211120", label: "Crude Petroleum Extraction" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Oil and Gas Extraction"
    },
    "211130": {
      value: { code: "211130", label: "Natural Gas Extraction" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Oil and Gas Extraction"
    },
    "212114": {
      value: { code: "212114", label: "Surface Coal Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Coal Mining"
    },
    "212115": {
      value: { code: "212115", label: "Underground Coal Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Coal Mining"
    },
    "212210": {
      value: { code: "212210", label: "Iron Ore Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Metal Ore Mining"
    },
    "212220": {
      value: { code: "212220", label: "Gold Ore and Silver Ore Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Metal Ore Mining"
    },
    "212230": {
      value: { code: "212230", label: "Copper, Nickel, Lead, and Zinc Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Metal Ore Mining"
    },
    "212290": {
      value: { code: "212290", label: "Other Metal Ore Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Metal Ore Mining"
    },
    "212311": {
      value: { code: "212311", label: "Dimension Stone Mining and Quarrying" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212312": {
      value: {
        code: "212312",
        label: "Crushed and Broken Limestone Mining and Quarrying"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212313": {
      value: {
        code: "212313",
        label: "Crushed and Broken Granite Mining and Quarrying"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212319": {
      value: {
        code: "212319",
        label: "Other Crushed and Broken Stone Mining and Quarrying"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212321": {
      value: { code: "212321", label: "Construction Sand and Gravel Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212322": {
      value: { code: "212322", label: "Industrial Sand Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212323": {
      value: {
        code: "212323",
        label: "Kaolin, Clay, and Ceramic and Refractory Minerals Mining"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "212390": {
      value: {
        code: "212390",
        label: "Other Nonmetallic Mineral Mining and Quarrying"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Nonmetallic Mineral Mining and Quarrying"
    },
    "213111": {
      value: { code: "213111", label: "Drilling Oil and Gas Wells" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Support Activities for Mining"
    },
    "213112": {
      value: {
        code: "213112",
        label: "Support Activities for Oil and Gas Operations"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Support Activities for Mining"
    },
    "213113": {
      value: { code: "213113", label: "Support Activities for Coal Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Support Activities for Mining"
    },
    "213114": {
      value: { code: "213114", label: "Support Activities for Metal Mining" },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Support Activities for Mining"
    },
    "213115": {
      value: {
        code: "213115",
        label: "Support Activities for Nonmetallic Minerals (except Fuels) Mining"
      },
      industry: "Mining, Quarrying, and Oil and Gas Extraction",
      subcategory: "Support Activities for Mining"
    },
    "221111": {
      value: { code: "221111", label: "Hydroelectric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221112": {
      value: { code: "221112", label: "Fossil Fuel Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221113": {
      value: { code: "221113", label: "Nuclear Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221114": {
      value: { code: "221114", label: "Solar Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221115": {
      value: { code: "221115", label: "Wind Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221116": {
      value: { code: "221116", label: "Geothermal Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221117": {
      value: { code: "221117", label: "Biomass Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221118": {
      value: { code: "221118", label: "Other Electric Power Generation" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221121": {
      value: {
        code: "221121",
        label: "Electric Bulk Power Transmission and Control"
      },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221122": {
      value: { code: "221122", label: "Electric Power Distribution" },
      industry: "Utilities",
      subcategory: "Electric Power Generation, Transmission and Distribution"
    },
    "221210": {
      value: { code: "221210", label: "Natural Gas Distribution" },
      industry: "Utilities",
      subcategory: "Natural Gas Distribution"
    },
    "221310": {
      value: { code: "221310", label: "Water Supply and Irrigation Systems" },
      industry: "Utilities",
      subcategory: "Water, Sewage and Other Systems"
    },
    "221320": {
      value: { code: "221320", label: "Sewage Treatment Facilities" },
      industry: "Utilities",
      subcategory: "Water, Sewage and Other Systems"
    },
    "221330": {
      value: { code: "221330", label: "Steam and Air-Conditioning Supply" },
      industry: "Utilities",
      subcategory: "Water, Sewage and Other Systems"
    },
    "236115": {
      value: {
        code: "236115",
        label: "New Single-Family Housing Construction (except For-Sale Builders)"
      },
      industry: "Construction",
      subcategory: "Residential Building Construction"
    },
    "236116": {
      value: {
        code: "236116",
        label: "New Multifamily Housing Construction (except For-Sale Builders)"
      },
      industry: "Construction",
      subcategory: "Residential Building Construction"
    },
    "236117": {
      value: { code: "236117", label: "New Housing For-Sale Builders" },
      industry: "Construction",
      subcategory: "Residential Building Construction"
    },
    "236118": {
      value: { code: "236118", label: "Residential Remodelers" },
      industry: "Construction",
      subcategory: "Residential Building Construction"
    },
    "236210": {
      value: { code: "236210", label: "Industrial Building Construction" },
      industry: "Construction",
      subcategory: "Nonresidential Building Construction"
    },
    "236220": {
      value: {
        code: "236220",
        label: "Commercial and Institutional Building Construction"
      },
      industry: "Construction",
      subcategory: "Nonresidential Building Construction"
    },
    "237110": {
      value: {
        code: "237110",
        label: "Water and Sewer Line and Related Structures Construction"
      },
      industry: "Construction",
      subcategory: "Utility System Construction"
    },
    "237120": {
      value: {
        code: "237120",
        label: "Oil and Gas Pipeline and Related Structures Construction"
      },
      industry: "Construction",
      subcategory: "Utility System Construction"
    },
    "237130": {
      value: {
        code: "237130",
        label: "Power and Communication Line and Related Structures Construction"
      },
      industry: "Construction",
      subcategory: "Utility System Construction"
    },
    "237210": {
      value: { code: "237210", label: "Land Subdivision" },
      industry: "Construction",
      subcategory: "Land Subdivision"
    },
    "237310": {
      value: {
        code: "237310",
        label: "Highway, Street, and Bridge Construction"
      },
      industry: "Construction",
      subcategory: "Highway, Street, and Bridge Construction"
    },
    "237990": {
      value: {
        code: "237990",
        label: "Other Heavy and Civil Engineering Construction"
      },
      industry: "Construction",
      subcategory: "Other Heavy and Civil Engineering Construction"
    },
    "238110": {
      value: {
        code: "238110",
        label: "Poured Concrete Foundation and Structure Contractors"
      },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238120": {
      value: {
        code: "238120",
        label: "Structural Steel and Precast Concrete Contractors"
      },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238130": {
      value: { code: "238130", label: "Framing Contractors" },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238140": {
      value: { code: "238140", label: "Masonry Contractors" },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238150": {
      value: { code: "238150", label: "Glass and Glazing Contractors" },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238160": {
      value: { code: "238160", label: "Roofing Contractors" },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238170": {
      value: { code: "238170", label: "Siding Contractors" },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238190": {
      value: {
        code: "238190",
        label: "Other Foundation, Structure, and Building Exterior Contractors"
      },
      industry: "Construction",
      subcategory: "Foundation, Structure, and Building Exterior Contractors"
    },
    "238210": {
      value: {
        code: "238210",
        label: "Electrical Contractors and Other Wiring Installation Contractors"
      },
      industry: "Construction",
      subcategory: "Building Equipment Contractors"
    },
    "238220": {
      value: {
        code: "238220",
        label: "Plumbing, Heating, and Air-Conditioning Contractors"
      },
      industry: "Construction",
      subcategory: "Building Equipment Contractors"
    },
    "238290": {
      value: { code: "238290", label: "Other Building Equipment Contractors" },
      industry: "Construction",
      subcategory: "Building Equipment Contractors"
    },
    "238310": {
      value: { code: "238310", label: "Drywall and Insulation Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238320": {
      value: { code: "238320", label: "Painting and Wall Covering Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238330": {
      value: { code: "238330", label: "Flooring Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238340": {
      value: { code: "238340", label: "Tile and Terrazzo Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238350": {
      value: { code: "238350", label: "Finish Carpentry Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238390": {
      value: { code: "238390", label: "Other Building Finishing Contractors" },
      industry: "Construction",
      subcategory: "Building Finishing Contractors"
    },
    "238910": {
      value: { code: "238910", label: "Site Preparation Contractors" },
      industry: "Construction",
      subcategory: "Other Specialty Trade Contractors"
    },
    "238990": {
      value: { code: "238990", label: "All Other Specialty Trade Contractors" },
      industry: "Construction",
      subcategory: "Other Specialty Trade Contractors"
    },
    "311111": {
      value: { code: "311111", label: "Dog and Cat Food Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Animal Food Manufacturing"
    },
    "311119": {
      value: { code: "311119", label: "Other Animal Food Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Animal Food Manufacturing"
    },
    "311211": {
      value: { code: "311211", label: "Flour Milling" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311212": {
      value: { code: "311212", label: "Rice Milling" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311213": {
      value: { code: "311213", label: "Malt Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311221": {
      value: {
        code: "311221",
        label: "Wet Corn Milling and Starch Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311224": {
      value: { code: "311224", label: "Soybean and Other Oilseed Processing" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311225": {
      value: { code: "311225", label: "Fats and Oils Refining and Blending" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311230": {
      value: { code: "311230", label: "Breakfast Cereal Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Grain and Oilseed Milling"
    },
    "311313": {
      value: { code: "311313", label: "Beet Sugar Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Sugar and Confectionery Product Manufacturing"
    },
    "311314": {
      value: { code: "311314", label: "Cane Sugar Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Sugar and Confectionery Product Manufacturing"
    },
    "311340": {
      value: {
        code: "311340",
        label: "Nonchocolate Confectionery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Sugar and Confectionery Product Manufacturing"
    },
    "311351": {
      value: {
        code: "311351",
        label: "Chocolate and Confectionery Manufacturing from Cacao Beans"
      },
      industry: "Manufacturing",
      subcategory: "Sugar and Confectionery Product Manufacturing"
    },
    "311352": {
      value: {
        code: "311352",
        label: "Confectionery Manufacturing from Purchased Chocolate"
      },
      industry: "Manufacturing",
      subcategory: "Sugar and Confectionery Product Manufacturing"
    },
    "311411": {
      value: {
        code: "311411",
        label: "Frozen Fruit, Juice, and Vegetable Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Fruit and Vegetable Preserving and Specialty Food Manufacturing"
    },
    "311412": {
      value: { code: "311412", label: "Frozen Specialty Food Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Fruit and Vegetable Preserving and Specialty Food Manufacturing"
    },
    "311421": {
      value: { code: "311421", label: "Fruit and Vegetable Canning" },
      industry: "Manufacturing",
      subcategory: "Fruit and Vegetable Preserving and Specialty Food Manufacturing"
    },
    "311422": {
      value: { code: "311422", label: "Specialty Canning" },
      industry: "Manufacturing",
      subcategory: "Fruit and Vegetable Preserving and Specialty Food Manufacturing"
    },
    "311423": {
      value: {
        code: "311423",
        label: "Dried and Dehydrated Food Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Fruit and Vegetable Preserving and Specialty Food Manufacturing"
    },
    "311511": {
      value: { code: "311511", label: "Fluid Milk Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Dairy Product Manufacturing"
    },
    "311512": {
      value: { code: "311512", label: "Creamery Butter Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Dairy Product Manufacturing"
    },
    "311513": {
      value: { code: "311513", label: "Cheese Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Dairy Product Manufacturing"
    },
    "311514": {
      value: {
        code: "311514",
        label: "Dry, Condensed, and Evaporated Dairy Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Dairy Product Manufacturing"
    },
    "311520": {
      value: {
        code: "311520",
        label: "Ice Cream and Frozen Dessert Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Dairy Product Manufacturing"
    },
    "311611": {
      value: { code: "311611", label: "Animal (except Poultry) Slaughtering" },
      industry: "Manufacturing",
      subcategory: "Animal Slaughtering and Processing"
    },
    "311612": {
      value: { code: "311612", label: "Meat Processed from Carcasses" },
      industry: "Manufacturing",
      subcategory: "Animal Slaughtering and Processing"
    },
    "311613": {
      value: {
        code: "311613",
        label: "Rendering and Meat Byproduct Processing"
      },
      industry: "Manufacturing",
      subcategory: "Animal Slaughtering and Processing"
    },
    "311615": {
      value: { code: "311615", label: "Poultry Processing" },
      industry: "Manufacturing",
      subcategory: "Animal Slaughtering and Processing"
    },
    "311710": {
      value: {
        code: "311710",
        label: "Seafood Product Preparation and Packaging"
      },
      industry: "Manufacturing",
      subcategory: "Seafood Product Preparation and Packaging"
    },
    "311811": {
      value: { code: "311811", label: "Retail Bakeries" },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311812": {
      value: { code: "311812", label: "Commercial Bakeries" },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311813": {
      value: {
        code: "311813",
        label: "Frozen Cakes, Pies, and Other Pastries Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311821": {
      value: { code: "311821", label: "Cookie and Cracker Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311824": {
      value: {
        code: "311824",
        label: "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour"
      },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311830": {
      value: { code: "311830", label: "Tortilla Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Bakeries and Tortilla Manufacturing"
    },
    "311911": {
      value: {
        code: "311911",
        label: "Roasted Nuts and Peanut Butter Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311919": {
      value: { code: "311919", label: "Other Snack Food Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311920": {
      value: { code: "311920", label: "Coffee and Tea Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311930": {
      value: {
        code: "311930",
        label: "Flavoring Syrup and Concentrate Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311941": {
      value: {
        code: "311941",
        label: "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311942": {
      value: { code: "311942", label: "Spice and Extract Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311991": {
      value: { code: "311991", label: "Perishable Prepared Food Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "311999": {
      value: {
        code: "311999",
        label: "All Other Miscellaneous Food Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Food Manufacturing"
    },
    "312111": {
      value: { code: "312111", label: "Soft Drink Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312112": {
      value: { code: "312112", label: "Bottled Water Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312113": {
      value: { code: "312113", label: "Ice Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312120": {
      value: { code: "312120", label: "Breweries" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312130": {
      value: { code: "312130", label: "Wineries" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312140": {
      value: { code: "312140", label: "Distilleries" },
      industry: "Manufacturing",
      subcategory: "Beverage Manufacturing"
    },
    "312230": {
      value: { code: "312230", label: "Tobacco Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Tobacco Manufacturing"
    },
    "313110": {
      value: { code: "313110", label: "Fiber, Yarn, and Thread Mills" },
      industry: "Manufacturing",
      subcategory: "Fiber, Yarn, and Thread Mills"
    },
    "313210": {
      value: { code: "313210", label: "Broadwoven Fabric Mills" },
      industry: "Manufacturing",
      subcategory: "Fabric Mills"
    },
    "313220": {
      value: {
        code: "313220",
        label: "Narrow Fabric Mills and Schiffli Machine Embroidery"
      },
      industry: "Manufacturing",
      subcategory: "Fabric Mills"
    },
    "313230": {
      value: { code: "313230", label: "Nonwoven Fabric Mills" },
      industry: "Manufacturing",
      subcategory: "Fabric Mills"
    },
    "313240": {
      value: { code: "313240", label: "Knit Fabric Mills" },
      industry: "Manufacturing",
      subcategory: "Fabric Mills"
    },
    "313310": {
      value: { code: "313310", label: "Textile and Fabric Finishing Mills" },
      industry: "Manufacturing",
      subcategory: "Textile and Fabric Finishing and Fabric Coating Mills"
    },
    "313320": {
      value: { code: "313320", label: "Fabric Coating Mills" },
      industry: "Manufacturing",
      subcategory: "Textile and Fabric Finishing and Fabric Coating Mills"
    },
    "314110": {
      value: { code: "314110", label: "Carpet and Rug Mills" },
      industry: "Manufacturing",
      subcategory: "Textile Furnishings Mills"
    },
    "314120": {
      value: { code: "314120", label: "Curtain and Linen Mills" },
      industry: "Manufacturing",
      subcategory: "Textile Furnishings Mills"
    },
    "314910": {
      value: { code: "314910", label: "Textile Bag and Canvas Mills" },
      industry: "Manufacturing",
      subcategory: "Other Textile Product Mills"
    },
    "314994": {
      value: {
        code: "314994",
        label: "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills"
      },
      industry: "Manufacturing",
      subcategory: "Other Textile Product Mills"
    },
    "314999": {
      value: {
        code: "314999",
        label: "All Other Miscellaneous Textile Product Mills"
      },
      industry: "Manufacturing",
      subcategory: "Other Textile Product Mills"
    },
    "315120": {
      value: { code: "315120", label: "Apparel Knitting Mills" },
      industry: "Manufacturing",
      subcategory: "Apparel Knitting Mills"
    },
    "315210": {
      value: { code: "315210", label: "Cut and Sew Apparel Contractors" },
      industry: "Manufacturing",
      subcategory: "Cut and Sew Apparel Manufacturing"
    },
    "315250": {
      value: {
        code: "315250",
        label: "Cut and Sew Apparel Manufacturing (except Contractors)"
      },
      industry: "Manufacturing",
      subcategory: "Cut and Sew Apparel Manufacturing"
    },
    "315990": {
      value: {
        code: "315990",
        label: "Apparel Accessories and Other Apparel Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Apparel Accessories and Other Apparel Manufacturing"
    },
    "316110": {
      value: { code: "316110", label: "Leather and Hide Tanning and Finishing" },
      industry: "Manufacturing",
      subcategory: "Leather and Hide Tanning and Finishing"
    },
    "316210": {
      value: { code: "316210", label: "Footwear Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Footwear Manufacturing"
    },
    "316990": {
      value: {
        code: "316990",
        label: "Other Leather and Allied Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Leather and Allied Product Manufacturing"
    },
    "321113": {
      value: { code: "321113", label: "Sawmills" },
      industry: "Manufacturing",
      subcategory: "Sawmills and Wood Preservation"
    },
    "321114": {
      value: { code: "321114", label: "Wood Preservation" },
      industry: "Manufacturing",
      subcategory: "Sawmills and Wood Preservation"
    },
    "321211": {
      value: {
        code: "321211",
        label: "Hardwood Veneer and Plywood Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Veneer, Plywood, and Engineered Wood Product Manufacturing"
    },
    "321212": {
      value: {
        code: "321212",
        label: "Softwood Veneer and Plywood Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Veneer, Plywood, and Engineered Wood Product Manufacturing"
    },
    "321215": {
      value: { code: "321215", label: "Engineered Wood Member Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Veneer, Plywood, and Engineered Wood Product Manufacturing"
    },
    "321219": {
      value: {
        code: "321219",
        label: "Reconstituted Wood Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Veneer, Plywood, and Engineered Wood Product Manufacturing"
    },
    "321911": {
      value: { code: "321911", label: "Wood Window and Door Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321912": {
      value: {
        code: "321912",
        label: "Cut Stock, Resawing Lumber, and Planing"
      },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321918": {
      value: { code: "321918", label: "Other Millwork (including Flooring)" },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321920": {
      value: {
        code: "321920",
        label: "Wood Container and Pallet Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321991": {
      value: {
        code: "321991",
        label: "Manufactured Home (Mobile Home) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321992": {
      value: {
        code: "321992",
        label: "Prefabricated Wood Building Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "321999": {
      value: {
        code: "321999",
        label: "All Other Miscellaneous Wood Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Wood Product Manufacturing"
    },
    "322110": {
      value: { code: "322110", label: "Pulp Mills" },
      industry: "Manufacturing",
      subcategory: "Pulp, Paper, and Paperboard Mills"
    },
    "322120": {
      value: { code: "322120", label: "Paper Mills" },
      industry: "Manufacturing",
      subcategory: "Pulp, Paper, and Paperboard Mills"
    },
    "322130": {
      value: { code: "322130", label: "Paperboard Mills" },
      industry: "Manufacturing",
      subcategory: "Pulp, Paper, and Paperboard Mills"
    },
    "322211": {
      value: {
        code: "322211",
        label: "Corrugated and Solid Fiber Box Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322212": {
      value: { code: "322212", label: "Folding Paperboard Box Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322219": {
      value: {
        code: "322219",
        label: "Other Paperboard Container Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322220": {
      value: {
        code: "322220",
        label: "Paper Bag and Coated and Treated Paper Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322230": {
      value: { code: "322230", label: "Stationery Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322291": {
      value: { code: "322291", label: "Sanitary Paper Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "322299": {
      value: {
        code: "322299",
        label: "All Other Converted Paper Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Converted Paper Product Manufacturing"
    },
    "323111": {
      value: {
        code: "323111",
        label: "Commercial Printing (except Screen and Books)"
      },
      industry: "Manufacturing",
      subcategory: "Printing and Related Support Activities"
    },
    "323113": {
      value: { code: "323113", label: "Commercial Screen Printing" },
      industry: "Manufacturing",
      subcategory: "Printing and Related Support Activities"
    },
    "323117": {
      value: { code: "323117", label: "Books Printing" },
      industry: "Manufacturing",
      subcategory: "Printing and Related Support Activities"
    },
    "323120": {
      value: { code: "323120", label: "Support Activities for Printing" },
      industry: "Manufacturing",
      subcategory: "Printing and Related Support Activities"
    },
    "324110": {
      value: { code: "324110", label: "Petroleum Refineries" },
      industry: "Manufacturing",
      subcategory: "Petroleum and Coal Products Manufacturing"
    },
    "324121": {
      value: {
        code: "324121",
        label: "Asphalt Paving Mixture and Block Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Petroleum and Coal Products Manufacturing"
    },
    "324122": {
      value: {
        code: "324122",
        label: "Asphalt Shingle and Coating Materials Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Petroleum and Coal Products Manufacturing"
    },
    "324191": {
      value: {
        code: "324191",
        label: "Petroleum Lubricating Oil and Grease Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Petroleum and Coal Products Manufacturing"
    },
    "324199": {
      value: {
        code: "324199",
        label: "All Other Petroleum and Coal Products Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Petroleum and Coal Products Manufacturing"
    },
    "325110": {
      value: { code: "325110", label: "Petrochemical Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325120": {
      value: { code: "325120", label: "Industrial Gas Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325130": {
      value: {
        code: "325130",
        label: "Synthetic Dye and Pigment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325180": {
      value: {
        code: "325180",
        label: "Other Basic Inorganic Chemical Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325193": {
      value: { code: "325193", label: "Ethyl Alcohol Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325194": {
      value: {
        code: "325194",
        label: "Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325199": {
      value: {
        code: "325199",
        label: "All Other Basic Organic Chemical Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Basic Chemical Manufacturing"
    },
    "325211": {
      value: {
        code: "325211",
        label: "Plastics Material and Resin Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing"
    },
    "325212": {
      value: { code: "325212", label: "Synthetic Rubber Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing"
    },
    "325220": {
      value: {
        code: "325220",
        label: "Artificial and Synthetic Fibers and Filaments Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing"
    },
    "325311": {
      value: { code: "325311", label: "Nitrogenous Fertilizer Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing"
    },
    "325312": {
      value: { code: "325312", label: "Phosphatic Fertilizer Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing"
    },
    "325314": {
      value: { code: "325314", label: "Fertilizer (Mixing Only) Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing"
    },
    "325315": {
      value: { code: "325315", label: "Compost Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing"
    },
    "325320": {
      value: {
        code: "325320",
        label: "Pesticide and Other Agricultural Chemical Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing"
    },
    "325411": {
      value: { code: "325411", label: "Medicinal and Botanical Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Pharmaceutical and Medicine Manufacturing"
    },
    "325412": {
      value: {
        code: "325412",
        label: "Pharmaceutical Preparation Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Pharmaceutical and Medicine Manufacturing"
    },
    "325413": {
      value: {
        code: "325413",
        label: "In-Vitro Diagnostic Substance Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Pharmaceutical and Medicine Manufacturing"
    },
    "325414": {
      value: {
        code: "325414",
        label: "Biological Product (except Diagnostic) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Pharmaceutical and Medicine Manufacturing"
    },
    "325510": {
      value: { code: "325510", label: "Paint and Coating Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Paint, Coating, and Adhesive Manufacturing"
    },
    "325520": {
      value: { code: "325520", label: "Adhesive Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Paint, Coating, and Adhesive Manufacturing"
    },
    "325611": {
      value: { code: "325611", label: "Soap and Other Detergent Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Soap, Cleaning Compound, and Toilet Preparation Manufacturing"
    },
    "325612": {
      value: {
        code: "325612",
        label: "Polish and Other Sanitation Good Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Soap, Cleaning Compound, and Toilet Preparation Manufacturing"
    },
    "325613": {
      value: { code: "325613", label: "Surface Active Agent Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Soap, Cleaning Compound, and Toilet Preparation Manufacturing"
    },
    "325620": {
      value: { code: "325620", label: "Toilet Preparation Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Soap, Cleaning Compound, and Toilet Preparation Manufacturing"
    },
    "325910": {
      value: { code: "325910", label: "Printing Ink Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Chemical Product and Preparation Manufacturing"
    },
    "325920": {
      value: { code: "325920", label: "Explosives Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Chemical Product and Preparation Manufacturing"
    },
    "325991": {
      value: { code: "325991", label: "Custom Compounding of Purchased Resins" },
      industry: "Manufacturing",
      subcategory: "Other Chemical Product and Preparation Manufacturing"
    },
    "325992": {
      value: {
        code: "325992",
        label: "Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Chemical Product and Preparation Manufacturing"
    },
    "325998": {
      value: {
        code: "325998",
        label: "All Other Miscellaneous Chemical Product and Preparation Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Chemical Product and Preparation Manufacturing"
    },
    "326111": {
      value: { code: "326111", label: "Plastics Bag and Pouch Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326112": {
      value: {
        code: "326112",
        label: "Plastics Packaging Film and Sheet (including Laminated) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326113": {
      value: {
        code: "326113",
        label: "Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326121": {
      value: {
        code: "326121",
        label: "Unlaminated Plastics Profile Shape Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326122": {
      value: {
        code: "326122",
        label: "Plastics Pipe and Pipe Fitting Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326130": {
      value: {
        code: "326130",
        label: "Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326140": {
      value: { code: "326140", label: "Polystyrene Foam Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326150": {
      value: {
        code: "326150",
        label: "Urethane and Other Foam Product (except Polystyrene) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326160": {
      value: { code: "326160", label: "Plastics Bottle Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326191": {
      value: {
        code: "326191",
        label: "Plastics Plumbing Fixture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326199": {
      value: {
        code: "326199",
        label: "All Other Plastics Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Plastics Product Manufacturing"
    },
    "326211": {
      value: { code: "326211", label: "Tire Manufacturing (except Retreading)" },
      industry: "Manufacturing",
      subcategory: "Rubber Product Manufacturing"
    },
    "326212": {
      value: { code: "326212", label: "Tire Retreading" },
      industry: "Manufacturing",
      subcategory: "Rubber Product Manufacturing"
    },
    "326220": {
      value: {
        code: "326220",
        label: "Rubber and Plastics Hoses and Belting Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Rubber Product Manufacturing"
    },
    "326291": {
      value: {
        code: "326291",
        label: "Rubber Product Manufacturing for Mechanical Use"
      },
      industry: "Manufacturing",
      subcategory: "Rubber Product Manufacturing"
    },
    "326299": {
      value: { code: "326299", label: "All Other Rubber Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Rubber Product Manufacturing"
    },
    "327110": {
      value: {
        code: "327110",
        label: "Pottery, Ceramics, and Plumbing Fixture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Clay Product and Refractory Manufacturing"
    },
    "327120": {
      value: {
        code: "327120",
        label: "Clay Building Material and Refractories Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Clay Product and Refractory Manufacturing"
    },
    "327211": {
      value: { code: "327211", label: "Flat Glass Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Glass and Glass Product Manufacturing"
    },
    "327212": {
      value: {
        code: "327212",
        label: "Other Pressed and Blown Glass and Glassware Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Glass and Glass Product Manufacturing"
    },
    "327213": {
      value: { code: "327213", label: "Glass Container Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Glass and Glass Product Manufacturing"
    },
    "327215": {
      value: {
        code: "327215",
        label: "Glass Product Manufacturing Made of Purchased Glass"
      },
      industry: "Manufacturing",
      subcategory: "Glass and Glass Product Manufacturing"
    },
    "327310": {
      value: { code: "327310", label: "Cement Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cement and Concrete Product Manufacturing"
    },
    "327320": {
      value: { code: "327320", label: "Ready-Mix Concrete Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cement and Concrete Product Manufacturing"
    },
    "327331": {
      value: { code: "327331", label: "Concrete Block and Brick Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cement and Concrete Product Manufacturing"
    },
    "327332": {
      value: { code: "327332", label: "Concrete Pipe Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cement and Concrete Product Manufacturing"
    },
    "327390": {
      value: { code: "327390", label: "Other Concrete Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cement and Concrete Product Manufacturing"
    },
    "327410": {
      value: { code: "327410", label: "Lime Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Lime and Gypsum Product Manufacturing"
    },
    "327420": {
      value: { code: "327420", label: "Gypsum Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Lime and Gypsum Product Manufacturing"
    },
    "327910": {
      value: { code: "327910", label: "Abrasive Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Nonmetallic Mineral Product Manufacturing"
    },
    "327991": {
      value: {
        code: "327991",
        label: "Cut Stone and Stone Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Nonmetallic Mineral Product Manufacturing"
    },
    "327992": {
      value: {
        code: "327992",
        label: "Ground or Treated Mineral and Earth Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Nonmetallic Mineral Product Manufacturing"
    },
    "327993": {
      value: { code: "327993", label: "Mineral Wool Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Nonmetallic Mineral Product Manufacturing"
    },
    "327999": {
      value: {
        code: "327999",
        label: "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Nonmetallic Mineral Product Manufacturing"
    },
    "331110": {
      value: {
        code: "331110",
        label: "Iron and Steel Mills and Ferroalloy Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Iron and Steel Mills and Ferroalloy Manufacturing"
    },
    "331210": {
      value: {
        code: "331210",
        label: "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel"
      },
      industry: "Manufacturing",
      subcategory: "Steel Product Manufacturing from Purchased Steel"
    },
    "331221": {
      value: { code: "331221", label: "Rolled Steel Shape Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Steel Product Manufacturing from Purchased Steel"
    },
    "331222": {
      value: { code: "331222", label: "Steel Wire Drawing" },
      industry: "Manufacturing",
      subcategory: "Steel Product Manufacturing from Purchased Steel"
    },
    "331313": {
      value: {
        code: "331313",
        label: "Alumina Refining and Primary Aluminum Production"
      },
      industry: "Manufacturing",
      subcategory: "Alumina and Aluminum Production and Processing"
    },
    "331314": {
      value: {
        code: "331314",
        label: "Secondary Smelting and Alloying of Aluminum"
      },
      industry: "Manufacturing",
      subcategory: "Alumina and Aluminum Production and Processing"
    },
    "331315": {
      value: {
        code: "331315",
        label: "Aluminum Sheet, Plate, and Foil Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Alumina and Aluminum Production and Processing"
    },
    "331318": {
      value: {
        code: "331318",
        label: "Other Aluminum Rolling, Drawing, and Extruding"
      },
      industry: "Manufacturing",
      subcategory: "Alumina and Aluminum Production and Processing"
    },
    "331410": {
      value: {
        code: "331410",
        label: "Nonferrous Metal (except Aluminum) Smelting and Refining"
      },
      industry: "Manufacturing",
      subcategory: "Nonferrous Metal (except Aluminum) Production and Processing"
    },
    "331420": {
      value: {
        code: "331420",
        label: "Copper Rolling, Drawing, Extruding, and Alloying"
      },
      industry: "Manufacturing",
      subcategory: "Nonferrous Metal (except Aluminum) Production and Processing"
    },
    "331491": {
      value: {
        code: "331491",
        label: "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding"
      },
      industry: "Manufacturing",
      subcategory: "Nonferrous Metal (except Aluminum) Production and Processing"
    },
    "331492": {
      value: {
        code: "331492",
        label: "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)"
      },
      industry: "Manufacturing",
      subcategory: "Nonferrous Metal (except Aluminum) Production and Processing"
    },
    "331511": {
      value: { code: "331511", label: "Iron Foundries" },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "331512": {
      value: { code: "331512", label: "Steel Investment Foundries" },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "331513": {
      value: { code: "331513", label: "Steel Foundries (except Investment)" },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "331523": {
      value: { code: "331523", label: "Nonferrous Metal Die-Casting Foundries" },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "331524": {
      value: {
        code: "331524",
        label: "Aluminum Foundries (except Die-Casting)"
      },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "331529": {
      value: {
        code: "331529",
        label: "Other Nonferrous Metal Foundries (except Die-Casting)"
      },
      industry: "Manufacturing",
      subcategory: "Foundries"
    },
    "332111": {
      value: { code: "332111", label: "Iron and Steel Forging" },
      industry: "Manufacturing",
      subcategory: "Forging and Stamping"
    },
    "332112": {
      value: { code: "332112", label: "Nonferrous Forging" },
      industry: "Manufacturing",
      subcategory: "Forging and Stamping"
    },
    "332114": {
      value: { code: "332114", label: "Custom Roll Forming" },
      industry: "Manufacturing",
      subcategory: "Forging and Stamping"
    },
    "332117": {
      value: { code: "332117", label: "Powder Metallurgy Part Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Forging and Stamping"
    },
    "332119": {
      value: {
        code: "332119",
        label: "Metal Crown, Closure, and Other Metal Stamping (except Automotive)"
      },
      industry: "Manufacturing",
      subcategory: "Forging and Stamping"
    },
    "332215": {
      value: {
        code: "332215",
        label: "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Cutlery and Handtool Manufacturing"
    },
    "332216": {
      value: { code: "332216", label: "Saw Blade and Handtool Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Cutlery and Handtool Manufacturing"
    },
    "332311": {
      value: {
        code: "332311",
        label: "Prefabricated Metal Building and Component Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332312": {
      value: {
        code: "332312",
        label: "Fabricated Structural Metal Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332313": {
      value: { code: "332313", label: "Plate Work Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332321": {
      value: { code: "332321", label: "Metal Window and Door Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332322": {
      value: { code: "332322", label: "Sheet Metal Work Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332323": {
      value: {
        code: "332323",
        label: "Ornamental and Architectural Metal Work Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Architectural and Structural Metals Manufacturing"
    },
    "332410": {
      value: {
        code: "332410",
        label: "Power Boiler and Heat Exchanger Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Boiler, Tank, and Shipping Container Manufacturing"
    },
    "332420": {
      value: { code: "332420", label: "Metal Tank (Heavy Gauge) Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Boiler, Tank, and Shipping Container Manufacturing"
    },
    "332431": {
      value: { code: "332431", label: "Metal Can Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Boiler, Tank, and Shipping Container Manufacturing"
    },
    "332439": {
      value: { code: "332439", label: "Other Metal Container Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Boiler, Tank, and Shipping Container Manufacturing"
    },
    "332510": {
      value: { code: "332510", label: "Hardware Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Hardware Manufacturing"
    },
    "332613": {
      value: { code: "332613", label: "Spring Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Spring and Wire Product Manufacturing"
    },
    "332618": {
      value: {
        code: "332618",
        label: "Other Fabricated Wire Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Spring and Wire Product Manufacturing"
    },
    "332710": {
      value: { code: "332710", label: "Machine Shops" },
      industry: "Manufacturing",
      subcategory: "Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing"
    },
    "332721": {
      value: { code: "332721", label: "Precision Turned Product Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing"
    },
    "332722": {
      value: {
        code: "332722",
        label: "Bolt, Nut, Screw, Rivet, and Washer Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing"
    },
    "332811": {
      value: { code: "332811", label: "Metal Heat Treating" },
      industry: "Manufacturing",
      subcategory: "Coating, Engraving, Heat Treating, and Allied Activities"
    },
    "332812": {
      value: {
        code: "332812",
        label: "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers"
      },
      industry: "Manufacturing",
      subcategory: "Coating, Engraving, Heat Treating, and Allied Activities"
    },
    "332813": {
      value: {
        code: "332813",
        label: "Electroplating, Plating, Polishing, Anodizing, and Coloring"
      },
      industry: "Manufacturing",
      subcategory: "Coating, Engraving, Heat Treating, and Allied Activities"
    },
    "332911": {
      value: { code: "332911", label: "Industrial Valve Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332912": {
      value: {
        code: "332912",
        label: "Fluid Power Valve and Hose Fitting Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332913": {
      value: {
        code: "332913",
        label: "Plumbing Fixture Fitting and Trim Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332919": {
      value: {
        code: "332919",
        label: "Other Metal Valve and Pipe Fitting Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332991": {
      value: { code: "332991", label: "Ball and Roller Bearing Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332992": {
      value: { code: "332992", label: "Small Arms Ammunition Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332993": {
      value: {
        code: "332993",
        label: "Ammunition (except Small Arms) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332994": {
      value: {
        code: "332994",
        label: "Small Arms, Ordnance, and Ordnance Accessories Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332996": {
      value: {
        code: "332996",
        label: "Fabricated Pipe and Pipe Fitting Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "332999": {
      value: {
        code: "332999",
        label: "All Other Miscellaneous Fabricated Metal Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Fabricated Metal Product Manufacturing"
    },
    "333111": {
      value: {
        code: "333111",
        label: "Farm Machinery and Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Agriculture, Construction, and Mining Machinery Manufacturing"
    },
    "333112": {
      value: {
        code: "333112",
        label: "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Agriculture, Construction, and Mining Machinery Manufacturing"
    },
    "333120": {
      value: { code: "333120", label: "Construction Machinery Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Agriculture, Construction, and Mining Machinery Manufacturing"
    },
    "333131": {
      value: {
        code: "333131",
        label: "Mining Machinery and Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Agriculture, Construction, and Mining Machinery Manufacturing"
    },
    "333132": {
      value: {
        code: "333132",
        label: "Oil and Gas Field Machinery and Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Agriculture, Construction, and Mining Machinery Manufacturing"
    },
    "333241": {
      value: { code: "333241", label: "Food Product Machinery Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Industrial Machinery Manufacturing"
    },
    "333242": {
      value: { code: "333242", label: "Semiconductor Machinery Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Industrial Machinery Manufacturing"
    },
    "333243": {
      value: {
        code: "333243",
        label: "Sawmill, Woodworking, and Paper Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Industrial Machinery Manufacturing"
    },
    "333248": {
      value: {
        code: "333248",
        label: "All Other Industrial Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Industrial Machinery Manufacturing"
    },
    "333310": {
      value: {
        code: "333310",
        label: "Commercial and Service Industry Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Commercial and Service Industry Machinery Manufacturing"
    },
    "333413": {
      value: {
        code: "333413",
        label: "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing"
    },
    "333414": {
      value: {
        code: "333414",
        label: "Heating Equipment (except Warm Air Furnaces) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing"
    },
    "333415": {
      value: {
        code: "333415",
        label: "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing"
    },
    "333511": {
      value: { code: "333511", label: "Industrial Mold Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Metalworking Machinery Manufacturing"
    },
    "333514": {
      value: {
        code: "333514",
        label: "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Metalworking Machinery Manufacturing"
    },
    "333515": {
      value: {
        code: "333515",
        label: "Cutting Tool and Machine Tool Accessory Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Metalworking Machinery Manufacturing"
    },
    "333517": {
      value: { code: "333517", label: "Machine Tool Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Metalworking Machinery Manufacturing"
    },
    "333519": {
      value: {
        code: "333519",
        label: "Rolling Mill and Other Metalworking Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Metalworking Machinery Manufacturing"
    },
    "333611": {
      value: {
        code: "333611",
        label: "Turbine and Turbine Generator Set Units Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Engine, Turbine, and Power Transmission Equipment Manufacturing"
    },
    "333612": {
      value: {
        code: "333612",
        label: "Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Engine, Turbine, and Power Transmission Equipment Manufacturing"
    },
    "333613": {
      value: {
        code: "333613",
        label: "Mechanical Power Transmission Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Engine, Turbine, and Power Transmission Equipment Manufacturing"
    },
    "333618": {
      value: { code: "333618", label: "Other Engine Equipment Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Engine, Turbine, and Power Transmission Equipment Manufacturing"
    },
    "333912": {
      value: { code: "333912", label: "Air and Gas Compressor Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333914": {
      value: {
        code: "333914",
        label: "Measuring, Dispensing, and Other Pumping Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333921": {
      value: {
        code: "333921",
        label: "Elevator and Moving Stairway Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333922": {
      value: {
        code: "333922",
        label: "Conveyor and Conveying Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333923": {
      value: {
        code: "333923",
        label: "Overhead Traveling Crane, Hoist, and Monorail System Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333924": {
      value: {
        code: "333924",
        label: "Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333991": {
      value: { code: "333991", label: "Power-Driven Handtool Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333992": {
      value: {
        code: "333992",
        label: "Welding and Soldering Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333993": {
      value: { code: "333993", label: "Packaging Machinery Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333994": {
      value: {
        code: "333994",
        label: "Industrial Process Furnace and Oven Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333995": {
      value: {
        code: "333995",
        label: "Fluid Power Cylinder and Actuator Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333996": {
      value: {
        code: "333996",
        label: "Fluid Power Pump and Motor Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "333998": {
      value: {
        code: "333998",
        label: "All Other Miscellaneous General Purpose Machinery Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other General Purpose Machinery Manufacturing"
    },
    "334111": {
      value: { code: "334111", label: "Electronic Computer Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Computer and Peripheral Equipment Manufacturing"
    },
    "334112": {
      value: { code: "334112", label: "Computer Storage Device Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Computer and Peripheral Equipment Manufacturing"
    },
    "334118": {
      value: {
        code: "334118",
        label: "Computer Terminal and Other Computer Peripheral Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Computer and Peripheral Equipment Manufacturing"
    },
    "334210": {
      value: { code: "334210", label: "Telephone Apparatus Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Communications Equipment Manufacturing"
    },
    "334220": {
      value: {
        code: "334220",
        label: "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Communications Equipment Manufacturing"
    },
    "334290": {
      value: {
        code: "334290",
        label: "Other Communications Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Communications Equipment Manufacturing"
    },
    "334310": {
      value: {
        code: "334310",
        label: "Audio and Video Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Audio and Video Equipment Manufacturing"
    },
    "334412": {
      value: {
        code: "334412",
        label: "Bare Printed Circuit Board Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334413": {
      value: {
        code: "334413",
        label: "Semiconductor and Related Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334416": {
      value: {
        code: "334416",
        label: "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334417": {
      value: { code: "334417", label: "Electronic Connector Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334418": {
      value: {
        code: "334418",
        label: "Printed Circuit Assembly (Electronic Assembly) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334419": {
      value: {
        code: "334419",
        label: "Other Electronic Component Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Semiconductor and Other Electronic Component Manufacturing"
    },
    "334510": {
      value: {
        code: "334510",
        label: "Electromedical and Electrotherapeutic Apparatus Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334511": {
      value: {
        code: "334511",
        label: "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334512": {
      value: {
        code: "334512",
        label: "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334513": {
      value: {
        code: "334513",
        label: "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334514": {
      value: {
        code: "334514",
        label: "Totalizing Fluid Meter and Counting Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334515": {
      value: {
        code: "334515",
        label: "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334516": {
      value: {
        code: "334516",
        label: "Analytical Laboratory Instrument Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334517": {
      value: { code: "334517", label: "Irradiation Apparatus Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334519": {
      value: {
        code: "334519",
        label: "Other Measuring and Controlling Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing"
    },
    "334610": {
      value: {
        code: "334610",
        label: "Manufacturing and Reproducing Magnetic and Optical Media"
      },
      industry: "Manufacturing",
      subcategory: "Manufacturing and Reproducing Magnetic and Optical Media"
    },
    "335131": {
      value: {
        code: "335131",
        label: "Residential Electric Lighting Fixture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electric Lighting Equipment Manufacturing"
    },
    "335132": {
      value: {
        code: "335132",
        label: "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electric Lighting Equipment Manufacturing"
    },
    "335139": {
      value: {
        code: "335139",
        label: "Electric Lamp Bulb and Other Lighting Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electric Lighting Equipment Manufacturing"
    },
    "335210": {
      value: {
        code: "335210",
        label: "Small Electrical Appliance Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household Appliance Manufacturing"
    },
    "335220": {
      value: {
        code: "335220",
        label: "Major Household Appliance Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household Appliance Manufacturing"
    },
    "335311": {
      value: {
        code: "335311",
        label: "Power, Distribution, and Specialty Transformer Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electrical Equipment Manufacturing"
    },
    "335312": {
      value: { code: "335312", label: "Motor and Generator Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Electrical Equipment Manufacturing"
    },
    "335313": {
      value: {
        code: "335313",
        label: "Switchgear and Switchboard Apparatus Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electrical Equipment Manufacturing"
    },
    "335314": {
      value: {
        code: "335314",
        label: "Relay and Industrial Control Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Electrical Equipment Manufacturing"
    },
    "335910": {
      value: { code: "335910", label: "Battery Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335921": {
      value: { code: "335921", label: "Fiber Optic Cable Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335929": {
      value: {
        code: "335929",
        label: "Other Communication and Energy Wire Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335931": {
      value: {
        code: "335931",
        label: "Current-Carrying Wiring Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335932": {
      value: {
        code: "335932",
        label: "Noncurrent-Carrying Wiring Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335991": {
      value: {
        code: "335991",
        label: "Carbon and Graphite Product Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "335999": {
      value: {
        code: "335999",
        label: "All Other Miscellaneous Electrical Equipment and Component Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Electrical Equipment and Component Manufacturing"
    },
    "336110": {
      value: {
        code: "336110",
        label: "Automobile and Light Duty Motor Vehicle Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Manufacturing"
    },
    "336120": {
      value: { code: "336120", label: "Heavy Duty Truck Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Manufacturing"
    },
    "336211": {
      value: { code: "336211", label: "Motor Vehicle Body Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Body and Trailer Manufacturing"
    },
    "336212": {
      value: { code: "336212", label: "Truck Trailer Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Body and Trailer Manufacturing"
    },
    "336213": {
      value: { code: "336213", label: "Motor Home Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Body and Trailer Manufacturing"
    },
    "336214": {
      value: {
        code: "336214",
        label: "Travel Trailer and Camper Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Body and Trailer Manufacturing"
    },
    "336310": {
      value: {
        code: "336310",
        label: "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336320": {
      value: {
        code: "336320",
        label: "Motor Vehicle Electrical and Electronic Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336330": {
      value: {
        code: "336330",
        label: "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336340": {
      value: {
        code: "336340",
        label: "Motor Vehicle Brake System Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336350": {
      value: {
        code: "336350",
        label: "Motor Vehicle Transmission and Power Train Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336360": {
      value: {
        code: "336360",
        label: "Motor Vehicle Seating and Interior Trim Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336370": {
      value: { code: "336370", label: "Motor Vehicle Metal Stamping" },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336390": {
      value: {
        code: "336390",
        label: "Other Motor Vehicle Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Motor Vehicle Parts Manufacturing"
    },
    "336411": {
      value: { code: "336411", label: "Aircraft Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336412": {
      value: {
        code: "336412",
        label: "Aircraft Engine and Engine Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336413": {
      value: {
        code: "336413",
        label: "Other Aircraft Parts and Auxiliary Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336414": {
      value: {
        code: "336414",
        label: "Guided Missile and Space Vehicle Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336415": {
      value: {
        code: "336415",
        label: "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336419": {
      value: {
        code: "336419",
        label: "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Aerospace Product and Parts Manufacturing"
    },
    "336510": {
      value: { code: "336510", label: "Railroad Rolling Stock Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Railroad Rolling Stock Manufacturing"
    },
    "336611": {
      value: { code: "336611", label: "Ship Building and Repairing" },
      industry: "Manufacturing",
      subcategory: "Ship and Boat Building"
    },
    "336612": {
      value: { code: "336612", label: "Boat Building" },
      industry: "Manufacturing",
      subcategory: "Ship and Boat Building"
    },
    "336991": {
      value: {
        code: "336991",
        label: "Motorcycle, Bicycle, and Parts Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Transportation Equipment Manufacturing"
    },
    "336992": {
      value: {
        code: "336992",
        label: "Military Armored Vehicle, Tank, and Tank Component Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Transportation Equipment Manufacturing"
    },
    "336999": {
      value: {
        code: "336999",
        label: "All Other Transportation Equipment Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Transportation Equipment Manufacturing"
    },
    "337110": {
      value: {
        code: "337110",
        label: "Wood Kitchen Cabinet and Countertop Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing"
    },
    "337121": {
      value: {
        code: "337121",
        label: "Upholstered Household Furniture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing"
    },
    "337122": {
      value: {
        code: "337122",
        label: "Nonupholstered Wood Household Furniture Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing"
    },
    "337126": {
      value: {
        code: "337126",
        label: "Household Furniture (except Wood and Upholstered) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing"
    },
    "337127": {
      value: { code: "337127", label: "Institutional Furniture Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing"
    },
    "337211": {
      value: { code: "337211", label: "Wood Office Furniture Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Office Furniture (including Fixtures) Manufacturing"
    },
    "337212": {
      value: {
        code: "337212",
        label: "Custom Architectural Woodwork and Millwork Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Office Furniture (including Fixtures) Manufacturing"
    },
    "337214": {
      value: {
        code: "337214",
        label: "Office Furniture (except Wood) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Office Furniture (including Fixtures) Manufacturing"
    },
    "337215": {
      value: {
        code: "337215",
        label: "Showcase, Partition, Shelving, and Locker Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Office Furniture (including Fixtures) Manufacturing"
    },
    "337910": {
      value: { code: "337910", label: "Mattress Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Furniture Related Product Manufacturing"
    },
    "337920": {
      value: { code: "337920", label: "Blind and Shade Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Furniture Related Product Manufacturing"
    },
    "339112": {
      value: {
        code: "339112",
        label: "Surgical and Medical Instrument Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Medical Equipment and Supplies Manufacturing"
    },
    "339113": {
      value: {
        code: "339113",
        label: "Surgical Appliance and Supplies Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Medical Equipment and Supplies Manufacturing"
    },
    "339114": {
      value: {
        code: "339114",
        label: "Dental Equipment and Supplies Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Medical Equipment and Supplies Manufacturing"
    },
    "339115": {
      value: { code: "339115", label: "Ophthalmic Goods Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Medical Equipment and Supplies Manufacturing"
    },
    "339116": {
      value: { code: "339116", label: "Dental Laboratories" },
      industry: "Manufacturing",
      subcategory: "Medical Equipment and Supplies Manufacturing"
    },
    "339910": {
      value: { code: "339910", label: "Jewelry and Silverware Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339920": {
      value: {
        code: "339920",
        label: "Sporting and Athletic Goods Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339930": {
      value: { code: "339930", label: "Doll, Toy, and Game Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339940": {
      value: {
        code: "339940",
        label: "Office Supplies (except Paper) Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339950": {
      value: { code: "339950", label: "Sign Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339991": {
      value: {
        code: "339991",
        label: "Gasket, Packing, and Sealing Device Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339992": {
      value: { code: "339992", label: "Musical Instrument Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339993": {
      value: {
        code: "339993",
        label: "Fastener, Button, Needle, and Pin Manufacturing"
      },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339994": {
      value: { code: "339994", label: "Broom, Brush, and Mop Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339995": {
      value: { code: "339995", label: "Burial Casket Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "339999": {
      value: { code: "339999", label: "All Other Miscellaneous Manufacturing" },
      industry: "Manufacturing",
      subcategory: "Other Miscellaneous Manufacturing"
    },
    "423110": {
      value: {
        code: "423110",
        label: "Automobile and Other Motor Vehicle Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers"
    },
    "423120": {
      value: {
        code: "423120",
        label: "Motor Vehicle Supplies and New Parts Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers"
    },
    "423130": {
      value: { code: "423130", label: "Tire and Tube Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers"
    },
    "423140": {
      value: {
        code: "423140",
        label: "Motor Vehicle Parts (Used) Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers"
    },
    "423210": {
      value: { code: "423210", label: "Furniture Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Furniture and Home Furnishing Merchant Wholesalers"
    },
    "423220": {
      value: { code: "423220", label: "Home Furnishing Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Furniture and Home Furnishing Merchant Wholesalers"
    },
    "423310": {
      value: {
        code: "423310",
        label: "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Lumber and Other Construction Materials Merchant Wholesalers"
    },
    "423320": {
      value: {
        code: "423320",
        label: "Brick, Stone, and Related Construction Material Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Lumber and Other Construction Materials Merchant Wholesalers"
    },
    "423330": {
      value: {
        code: "423330",
        label: "Roofing, Siding, and Insulation Material Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Lumber and Other Construction Materials Merchant Wholesalers"
    },
    "423390": {
      value: {
        code: "423390",
        label: "Other Construction Material Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Lumber and Other Construction Materials Merchant Wholesalers"
    },
    "423410": {
      value: {
        code: "423410",
        label: "Photographic Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423420": {
      value: { code: "423420", label: "Office Equipment Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423430": {
      value: {
        code: "423430",
        label: "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423440": {
      value: {
        code: "423440",
        label: "Other Commercial Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423450": {
      value: {
        code: "423450",
        label: "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423460": {
      value: { code: "423460", label: "Ophthalmic Goods Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423490": {
      value: {
        code: "423490",
        label: "Other Professional Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Professional and Commercial Equipment and Supplies Merchant Wholesalers"
    },
    "423510": {
      value: {
        code: "423510",
        label: "Metal Service Centers and Other Metal Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Metal and Mineral (except Petroleum) Merchant Wholesalers"
    },
    "423520": {
      value: {
        code: "423520",
        label: "Coal and Other Mineral and Ore Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Metal and Mineral (except Petroleum) Merchant Wholesalers"
    },
    "423610": {
      value: {
        code: "423610",
        label: "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers"
    },
    "423620": {
      value: {
        code: "423620",
        label: "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers"
    },
    "423690": {
      value: {
        code: "423690",
        label: "Other Electronic Parts and Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers"
    },
    "423710": {
      value: { code: "423710", label: "Hardware Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers"
    },
    "423720": {
      value: {
        code: "423720",
        label: "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers"
    },
    "423730": {
      value: {
        code: "423730",
        label: "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers"
    },
    "423740": {
      value: {
        code: "423740",
        label: "Refrigeration Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers"
    },
    "423810": {
      value: {
        code: "423810",
        label: "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423820": {
      value: {
        code: "423820",
        label: "Farm and Garden Machinery and Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423830": {
      value: {
        code: "423830",
        label: "Industrial Machinery and Equipment Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423840": {
      value: {
        code: "423840",
        label: "Industrial Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423850": {
      value: {
        code: "423850",
        label: "Service Establishment Equipment and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423860": {
      value: {
        code: "423860",
        label: "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Machinery, Equipment, and Supplies Merchant Wholesalers"
    },
    "423910": {
      value: {
        code: "423910",
        label: "Sporting and Recreational Goods and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Durable Goods Merchant Wholesalers"
    },
    "423920": {
      value: {
        code: "423920",
        label: "Toy and Hobby Goods and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Durable Goods Merchant Wholesalers"
    },
    "423930": {
      value: {
        code: "423930",
        label: "Recyclable Material Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Durable Goods Merchant Wholesalers"
    },
    "423940": {
      value: {
        code: "423940",
        label: "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Durable Goods Merchant Wholesalers"
    },
    "423990": {
      value: {
        code: "423990",
        label: "Other Miscellaneous Durable Goods Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Durable Goods Merchant Wholesalers"
    },
    "424110": {
      value: {
        code: "424110",
        label: "Printing and Writing Paper Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Paper and Paper Product Merchant Wholesalers"
    },
    "424120": {
      value: {
        code: "424120",
        label: "Stationery and Office Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Paper and Paper Product Merchant Wholesalers"
    },
    "424130": {
      value: {
        code: "424130",
        label: "Industrial and Personal Service Paper Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Paper and Paper Product Merchant Wholesalers"
    },
    "424210": {
      value: {
        code: "424210",
        label: "Drugs and Druggists' Sundries Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Drugs and Druggists' Sundries Merchant Wholesalers"
    },
    "424310": {
      value: {
        code: "424310",
        label: "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Apparel, Piece Goods, and Notions Merchant Wholesalers"
    },
    "424340": {
      value: { code: "424340", label: "Footwear Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Apparel, Piece Goods, and Notions Merchant Wholesalers"
    },
    "424350": {
      value: {
        code: "424350",
        label: "Clothing and Clothing Accessories Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Apparel, Piece Goods, and Notions Merchant Wholesalers"
    },
    "424410": {
      value: {
        code: "424410",
        label: "General Line Grocery Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424420": {
      value: {
        code: "424420",
        label: "Packaged Frozen Food Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424430": {
      value: {
        code: "424430",
        label: "Dairy Product (except Dried or Canned) Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424440": {
      value: {
        code: "424440",
        label: "Poultry and Poultry Product Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424450": {
      value: { code: "424450", label: "Confectionery Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424460": {
      value: { code: "424460", label: "Fish and Seafood Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424470": {
      value: {
        code: "424470",
        label: "Meat and Meat Product Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424480": {
      value: {
        code: "424480",
        label: "Fresh Fruit and Vegetable Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424490": {
      value: {
        code: "424490",
        label: "Other Grocery and Related Products Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Grocery and Related Product Merchant Wholesalers"
    },
    "424510": {
      value: {
        code: "424510",
        label: "Grain and Field Bean Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Farm Product Raw Material Merchant Wholesalers"
    },
    "424520": {
      value: { code: "424520", label: "Livestock Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Farm Product Raw Material Merchant Wholesalers"
    },
    "424590": {
      value: {
        code: "424590",
        label: "Other Farm Product Raw Material Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Farm Product Raw Material Merchant Wholesalers"
    },
    "424610": {
      value: {
        code: "424610",
        label: "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Chemical and Allied Products Merchant Wholesalers"
    },
    "424690": {
      value: {
        code: "424690",
        label: "Other Chemical and Allied Products Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Chemical and Allied Products Merchant Wholesalers"
    },
    "424710": {
      value: { code: "424710", label: "Petroleum Bulk Stations and Terminals" },
      industry: "Wholesale Trade",
      subcategory: "Petroleum and Petroleum Products Merchant Wholesalers"
    },
    "424720": {
      value: {
        code: "424720",
        label: "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)"
      },
      industry: "Wholesale Trade",
      subcategory: "Petroleum and Petroleum Products Merchant Wholesalers"
    },
    "424810": {
      value: { code: "424810", label: "Beer and Ale Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers"
    },
    "424820": {
      value: {
        code: "424820",
        label: "Wine and Distilled Alcoholic Beverage Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers"
    },
    "424910": {
      value: { code: "424910", label: "Farm Supplies Merchant Wholesalers" },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "424920": {
      value: {
        code: "424920",
        label: "Book, Periodical, and Newspaper Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "424930": {
      value: {
        code: "424930",
        label: "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "424940": {
      value: {
        code: "424940",
        label: "Tobacco Product and Electronic Cigarette Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "424950": {
      value: {
        code: "424950",
        label: "Paint, Varnish, and Supplies Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "424990": {
      value: {
        code: "424990",
        label: "Other Miscellaneous Nondurable Goods Merchant Wholesalers"
      },
      industry: "Wholesale Trade",
      subcategory: "Miscellaneous Nondurable Goods Merchant Wholesalers"
    },
    "425120": {
      value: { code: "425120", label: "Wholesale Trade Agents and Brokers" },
      industry: "Wholesale Trade",
      subcategory: "Wholesale Trade Agents and Brokers"
    },
    "441110": {
      value: { code: "441110", label: "New Car Dealers" },
      industry: "Retail Trade",
      subcategory: "Automobile Dealers"
    },
    "441120": {
      value: { code: "441120", label: "Used Car Dealers" },
      industry: "Retail Trade",
      subcategory: "Automobile Dealers"
    },
    "441210": {
      value: { code: "441210", label: "Recreational Vehicle Dealers" },
      industry: "Retail Trade",
      subcategory: "Other Motor Vehicle Dealers"
    },
    "441222": {
      value: { code: "441222", label: "Boat Dealers" },
      industry: "Retail Trade",
      subcategory: "Other Motor Vehicle Dealers"
    },
    "441227": {
      value: {
        code: "441227",
        label: "Motorcycle, ATV, and All Other Motor Vehicle Dealers"
      },
      industry: "Retail Trade",
      subcategory: "Other Motor Vehicle Dealers"
    },
    "441330": {
      value: {
        code: "441330",
        label: "Automotive Parts and Accessories Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Automotive Parts, Accessories, and Tire Retailers"
    },
    "441340": {
      value: { code: "441340", label: "Tire Dealers" },
      industry: "Retail Trade",
      subcategory: "Automotive Parts, Accessories, and Tire Retailers"
    },
    "444110": {
      value: { code: "444110", label: "Home Centers" },
      industry: "Retail Trade",
      subcategory: "Building Material and Supplies Dealers"
    },
    "444120": {
      value: { code: "444120", label: "Paint and Wallpaper Retailers" },
      industry: "Retail Trade",
      subcategory: "Building Material and Supplies Dealers"
    },
    "444140": {
      value: { code: "444140", label: "Hardware Retailers" },
      industry: "Retail Trade",
      subcategory: "Building Material and Supplies Dealers"
    },
    "444180": {
      value: { code: "444180", label: "Other Building Material Dealers" },
      industry: "Retail Trade",
      subcategory: "Building Material and Supplies Dealers"
    },
    "444230": {
      value: { code: "444230", label: "Outdoor Power Equipment Retailers" },
      industry: "Retail Trade",
      subcategory: "Lawn and Garden Equipment and Supplies Retailers"
    },
    "444240": {
      value: {
        code: "444240",
        label: "Nursery, Garden Center, and Farm Supply Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Lawn and Garden Equipment and Supplies Retailers"
    },
    "445110": {
      value: {
        code: "445110",
        label: "Supermarkets and Other Grocery Retailers (except Convenience Retailers)"
      },
      industry: "Retail Trade",
      subcategory: "Grocery and Convenience Retailers"
    },
    "445131": {
      value: { code: "445131", label: "Convenience Retailers" },
      industry: "Retail Trade",
      subcategory: "Grocery and Convenience Retailers"
    },
    "445132": {
      value: { code: "445132", label: "Vending Machine Operators" },
      industry: "Retail Trade",
      subcategory: "Grocery and Convenience Retailers"
    },
    "445230": {
      value: { code: "445230", label: "Fruit and Vegetable Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445240": {
      value: { code: "445240", label: "Meat Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445250": {
      value: { code: "445250", label: "Fish and Seafood Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445291": {
      value: { code: "445291", label: "Baked Goods Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445292": {
      value: { code: "445292", label: "Confectionery and Nut Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445298": {
      value: { code: "445298", label: "All Other Specialty Food Retailers" },
      industry: "Retail Trade",
      subcategory: "Specialty Food Retailers"
    },
    "445320": {
      value: { code: "445320", label: "Beer, Wine, and Liquor Retailers" },
      industry: "Retail Trade",
      subcategory: "Beer, Wine, and Liquor Retailers"
    },
    "449110": {
      value: { code: "449110", label: "Furniture Retailers" },
      industry: "Retail Trade",
      subcategory: "Furniture and Home Furnishings Retailers"
    },
    "449121": {
      value: { code: "449121", label: "Floor Covering Retailers" },
      industry: "Retail Trade",
      subcategory: "Furniture and Home Furnishings Retailers"
    },
    "449122": {
      value: { code: "449122", label: "Window Treatment Retailers" },
      industry: "Retail Trade",
      subcategory: "Furniture and Home Furnishings Retailers"
    },
    "449129": {
      value: { code: "449129", label: "All Other Home Furnishings Retailers" },
      industry: "Retail Trade",
      subcategory: "Furniture and Home Furnishings Retailers"
    },
    "449210": {
      value: { code: "449210", label: "Electronics and Appliance Retailers" },
      industry: "Retail Trade",
      subcategory: "Electronics and Appliance Retailers"
    },
    "455110": {
      value: { code: "455110", label: "Department Stores" },
      industry: "Retail Trade",
      subcategory: "Department Stores"
    },
    "455211": {
      value: { code: "455211", label: "Warehouse Clubs and Supercenters" },
      industry: "Retail Trade",
      subcategory: "Warehouse Clubs, Supercenters, and Other General Merchandise Retailers"
    },
    "455219": {
      value: {
        code: "455219",
        label: "All Other General Merchandise Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Warehouse Clubs, Supercenters, and Other General Merchandise Retailers"
    },
    "456110": {
      value: { code: "456110", label: "Pharmacies and Drug Retailers" },
      industry: "Retail Trade",
      subcategory: "Health and Personal Care Retailers"
    },
    "456120": {
      value: {
        code: "456120",
        label: "Cosmetics, Beauty Supplies, and Perfume Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Health and Personal Care Retailers"
    },
    "456130": {
      value: { code: "456130", label: "Optical Goods Retailers" },
      industry: "Retail Trade",
      subcategory: "Health and Personal Care Retailers"
    },
    "456191": {
      value: { code: "456191", label: "Food (Health) Supplement Retailers" },
      industry: "Retail Trade",
      subcategory: "Health and Personal Care Retailers"
    },
    "456199": {
      value: {
        code: "456199",
        label: "All Other Health and Personal Care Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Health and Personal Care Retailers"
    },
    "457110": {
      value: {
        code: "457110",
        label: "Gasoline Stations with Convenience Stores"
      },
      industry: "Retail Trade",
      subcategory: "Gasoline Stations"
    },
    "457120": {
      value: { code: "457120", label: "Other Gasoline Stations" },
      industry: "Retail Trade",
      subcategory: "Gasoline Stations"
    },
    "457210": {
      value: { code: "457210", label: "Fuel Dealers" },
      industry: "Retail Trade",
      subcategory: "Fuel Dealers"
    },
    "458110": {
      value: {
        code: "458110",
        label: "Clothing and Clothing Accessories Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Clothing and Clothing Accessories Retailers"
    },
    "458210": {
      value: { code: "458210", label: "Shoe Retailers" },
      industry: "Retail Trade",
      subcategory: "Shoe Retailers"
    },
    "458310": {
      value: { code: "458310", label: "Jewelry Retailers" },
      industry: "Retail Trade",
      subcategory: "Jewelry, Luggage, and Leather Goods Retailers"
    },
    "458320": {
      value: { code: "458320", label: "Luggage and Leather Goods Retailers" },
      industry: "Retail Trade",
      subcategory: "Jewelry, Luggage, and Leather Goods Retailers"
    },
    "459110": {
      value: { code: "459110", label: "Sporting Goods Retailers" },
      industry: "Retail Trade",
      subcategory: "Sporting Goods, Hobby, and Musical Instrument Retailers"
    },
    "459120": {
      value: { code: "459120", label: "Hobby, Toy, and Game Retailers" },
      industry: "Retail Trade",
      subcategory: "Sporting Goods, Hobby, and Musical Instrument Retailers"
    },
    "459130": {
      value: {
        code: "459130",
        label: "Sewing, Needlework, and Piece Goods Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Sporting Goods, Hobby, and Musical Instrument Retailers"
    },
    "459140": {
      value: {
        code: "459140",
        label: "Musical Instrument and Supplies Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Sporting Goods, Hobby, and Musical Instrument Retailers"
    },
    "459210": {
      value: { code: "459210", label: "Book Retailers and News Dealers" },
      industry: "Retail Trade",
      subcategory: "Book Retailers and News Dealers"
    },
    "459310": {
      value: { code: "459310", label: "Florists" },
      industry: "Retail Trade",
      subcategory: "Florists"
    },
    "459410": {
      value: {
        code: "459410",
        label: "Office Supplies and Stationery Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Office Supplies, Stationery, and Gift Retailers"
    },
    "459420": {
      value: { code: "459420", label: "Gift, Novelty, and Souvenir Retailers" },
      industry: "Retail Trade",
      subcategory: "Office Supplies, Stationery, and Gift Retailers"
    },
    "459510": {
      value: { code: "459510", label: "Used Merchandise Retailers" },
      industry: "Retail Trade",
      subcategory: "Used Merchandise Retailers"
    },
    "459910": {
      value: { code: "459910", label: "Pet and Pet Supplies Retailers" },
      industry: "Retail Trade",
      subcategory: "Other Miscellaneous Retailers"
    },
    "459920": {
      value: { code: "459920", label: "Art Dealers" },
      industry: "Retail Trade",
      subcategory: "Other Miscellaneous Retailers"
    },
    "459930": {
      value: { code: "459930", label: "Manufactured (Mobile) Home Dealers" },
      industry: "Retail Trade",
      subcategory: "Other Miscellaneous Retailers"
    },
    "459991": {
      value: {
        code: "459991",
        label: "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers"
      },
      industry: "Retail Trade",
      subcategory: "Other Miscellaneous Retailers"
    },
    "459999": {
      value: { code: "459999", label: "All Other Miscellaneous Retailers" },
      industry: "Retail Trade",
      subcategory: "Other Miscellaneous Retailers"
    },
    "481111": {
      value: { code: "481111", label: "Scheduled Passenger Air Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Scheduled Air Transportation"
    },
    "481112": {
      value: { code: "481112", label: "Scheduled Freight Air Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Scheduled Air Transportation"
    },
    "481211": {
      value: {
        code: "481211",
        label: "Nonscheduled Chartered Passenger Air Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Nonscheduled Air Transportation"
    },
    "481212": {
      value: {
        code: "481212",
        label: "Nonscheduled Chartered Freight Air Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Nonscheduled Air Transportation"
    },
    "481219": {
      value: { code: "481219", label: "Other Nonscheduled Air Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Nonscheduled Air Transportation"
    },
    "482111": {
      value: { code: "482111", label: "Line-Haul Railroads" },
      industry: "Transportation and Warehousing",
      subcategory: "Rail Transportation"
    },
    "482112": {
      value: { code: "482112", label: "Short Line Railroads" },
      industry: "Transportation and Warehousing",
      subcategory: "Rail Transportation"
    },
    "483111": {
      value: { code: "483111", label: "Deep Sea Freight Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Deep Sea, Coastal, and Great Lakes Water Transportation"
    },
    "483112": {
      value: { code: "483112", label: "Deep Sea Passenger Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Deep Sea, Coastal, and Great Lakes Water Transportation"
    },
    "483113": {
      value: {
        code: "483113",
        label: "Coastal and Great Lakes Freight Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Deep Sea, Coastal, and Great Lakes Water Transportation"
    },
    "483114": {
      value: {
        code: "483114",
        label: "Coastal and Great Lakes Passenger Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Deep Sea, Coastal, and Great Lakes Water Transportation"
    },
    "483211": {
      value: { code: "483211", label: "Inland Water Freight Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Inland Water Transportation"
    },
    "483212": {
      value: { code: "483212", label: "Inland Water Passenger Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Inland Water Transportation"
    },
    "484110": {
      value: { code: "484110", label: "General Freight Trucking, Local" },
      industry: "Transportation and Warehousing",
      subcategory: "General Freight Trucking"
    },
    "484121": {
      value: {
        code: "484121",
        label: "General Freight Trucking, Long-Distance, Truckload"
      },
      industry: "Transportation and Warehousing",
      subcategory: "General Freight Trucking"
    },
    "484122": {
      value: {
        code: "484122",
        label: "General Freight Trucking, Long-Distance, Less Than Truckload"
      },
      industry: "Transportation and Warehousing",
      subcategory: "General Freight Trucking"
    },
    "484210": {
      value: { code: "484210", label: "Used Household and Office Goods Moving" },
      industry: "Transportation and Warehousing",
      subcategory: "Specialized Freight Trucking"
    },
    "484220": {
      value: {
        code: "484220",
        label: "Specialized Freight (except Used Goods) Trucking, Local"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Specialized Freight Trucking"
    },
    "484230": {
      value: {
        code: "484230",
        label: "Specialized Freight (except Used Goods) Trucking, Long-Distance"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Specialized Freight Trucking"
    },
    "485111": {
      value: { code: "485111", label: "Mixed Mode Transit Systems" },
      industry: "Transportation and Warehousing",
      subcategory: "Urban Transit Systems"
    },
    "485112": {
      value: { code: "485112", label: "Commuter Rail Systems" },
      industry: "Transportation and Warehousing",
      subcategory: "Urban Transit Systems"
    },
    "485113": {
      value: {
        code: "485113",
        label: "Bus and Other Motor Vehicle Transit Systems"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Urban Transit Systems"
    },
    "485119": {
      value: { code: "485119", label: "Other Urban Transit Systems" },
      industry: "Transportation and Warehousing",
      subcategory: "Urban Transit Systems"
    },
    "485210": {
      value: {
        code: "485210",
        label: "Interurban and Rural Bus Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Interurban and Rural Bus Transportation"
    },
    "485310": {
      value: { code: "485310", label: "Taxi and Ridesharing Services" },
      industry: "Transportation and Warehousing",
      subcategory: "Taxi and Limousine Service"
    },
    "485320": {
      value: { code: "485320", label: "Limousine Service" },
      industry: "Transportation and Warehousing",
      subcategory: "Taxi and Limousine Service"
    },
    "485410": {
      value: { code: "485410", label: "School and Employee Bus Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "School and Employee Bus Transportation"
    },
    "485510": {
      value: { code: "485510", label: "Charter Bus Industry" },
      industry: "Transportation and Warehousing",
      subcategory: "Charter Bus Industry"
    },
    "485991": {
      value: { code: "485991", label: "Special Needs Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Other Transit and Ground Passenger Transportation"
    },
    "485999": {
      value: {
        code: "485999",
        label: "All Other Transit and Ground Passenger Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Other Transit and Ground Passenger Transportation"
    },
    "486110": {
      value: { code: "486110", label: "Pipeline Transportation of Crude Oil" },
      industry: "Transportation and Warehousing",
      subcategory: "Pipeline Transportation of Crude Oil"
    },
    "486210": {
      value: { code: "486210", label: "Pipeline Transportation of Natural Gas" },
      industry: "Transportation and Warehousing",
      subcategory: "Pipeline Transportation of Natural Gas"
    },
    "486910": {
      value: {
        code: "486910",
        label: "Pipeline Transportation of Refined Petroleum Products"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Other Pipeline Transportation"
    },
    "486990": {
      value: { code: "486990", label: "All Other Pipeline Transportation" },
      industry: "Transportation and Warehousing",
      subcategory: "Other Pipeline Transportation"
    },
    "487110": {
      value: {
        code: "487110",
        label: "Scenic and Sightseeing Transportation, Land"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Scenic and Sightseeing Transportation, Land"
    },
    "487210": {
      value: {
        code: "487210",
        label: "Scenic and Sightseeing Transportation, Water"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Scenic and Sightseeing Transportation, Water"
    },
    "487990": {
      value: {
        code: "487990",
        label: "Scenic and Sightseeing Transportation, Other"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Scenic and Sightseeing Transportation, Other"
    },
    "488111": {
      value: { code: "488111", label: "Air Traffic Control" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Air Transportation"
    },
    "488119": {
      value: { code: "488119", label: "Other Airport Operations" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Air Transportation"
    },
    "488190": {
      value: {
        code: "488190",
        label: "Other Support Activities for Air Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Air Transportation"
    },
    "488210": {
      value: {
        code: "488210",
        label: "Support Activities for Rail Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Rail Transportation"
    },
    "488310": {
      value: { code: "488310", label: "Port and Harbor Operations" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Water Transportation"
    },
    "488320": {
      value: { code: "488320", label: "Marine Cargo Handling" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Water Transportation"
    },
    "488330": {
      value: { code: "488330", label: "Navigational Services to Shipping" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Water Transportation"
    },
    "488390": {
      value: {
        code: "488390",
        label: "Other Support Activities for Water Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Water Transportation"
    },
    "488410": {
      value: { code: "488410", label: "Motor Vehicle Towing" },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Road Transportation"
    },
    "488490": {
      value: {
        code: "488490",
        label: "Other Support Activities for Road Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Support Activities for Road Transportation"
    },
    "488510": {
      value: { code: "488510", label: "Freight Transportation Arrangement" },
      industry: "Transportation and Warehousing",
      subcategory: "Freight Transportation Arrangement"
    },
    "488991": {
      value: { code: "488991", label: "Packing and Crating" },
      industry: "Transportation and Warehousing",
      subcategory: "Other Support Activities for Transportation"
    },
    "488999": {
      value: {
        code: "488999",
        label: "All Other Support Activities for Transportation"
      },
      industry: "Transportation and Warehousing",
      subcategory: "Other Support Activities for Transportation"
    },
    "491110": {
      value: { code: "491110", label: "Postal Service" },
      industry: "Transportation and Warehousing",
      subcategory: "Postal Service"
    },
    "492110": {
      value: { code: "492110", label: "Couriers and Express Delivery Services" },
      industry: "Transportation and Warehousing",
      subcategory: "Couriers and Express Delivery Services"
    },
    "492210": {
      value: { code: "492210", label: "Local Messengers and Local Delivery" },
      industry: "Transportation and Warehousing",
      subcategory: "Local Messengers and Local Delivery"
    },
    "493110": {
      value: { code: "493110", label: "General Warehousing and Storage" },
      industry: "Transportation and Warehousing",
      subcategory: "Warehousing and Storage"
    },
    "493120": {
      value: { code: "493120", label: "Refrigerated Warehousing and Storage" },
      industry: "Transportation and Warehousing",
      subcategory: "Warehousing and Storage"
    },
    "493130": {
      value: { code: "493130", label: "Farm Product Warehousing and Storage" },
      industry: "Transportation and Warehousing",
      subcategory: "Warehousing and Storage"
    },
    "493190": {
      value: { code: "493190", label: "Other Warehousing and Storage" },
      industry: "Transportation and Warehousing",
      subcategory: "Warehousing and Storage"
    },
    "512110": {
      value: { code: "512110", label: "Motion Picture and Video Production" },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512120": {
      value: { code: "512120", label: "Motion Picture and Video Distribution" },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512131": {
      value: {
        code: "512131",
        label: "Motion Picture Theaters (except Drive-Ins)"
      },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512132": {
      value: { code: "512132", label: "Drive-In Motion Picture Theaters" },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512191": {
      value: {
        code: "512191",
        label: "Teleproduction and Other Postproduction Services"
      },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512199": {
      value: {
        code: "512199",
        label: "Other Motion Picture and Video Industries"
      },
      industry: "Information",
      subcategory: "Motion Picture and Video Industries"
    },
    "512230": {
      value: { code: "512230", label: "Music Publishers" },
      industry: "Information",
      subcategory: "Sound Recording Industries"
    },
    "512240": {
      value: { code: "512240", label: "Sound Recording Studios" },
      industry: "Information",
      subcategory: "Sound Recording Industries"
    },
    "512250": {
      value: { code: "512250", label: "Record Production and Distribution" },
      industry: "Information",
      subcategory: "Sound Recording Industries"
    },
    "512290": {
      value: { code: "512290", label: "Other Sound Recording Industries" },
      industry: "Information",
      subcategory: "Sound Recording Industries"
    },
    "513110": {
      value: { code: "513110", label: "Newspaper Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513120": {
      value: { code: "513120", label: "Periodical Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513130": {
      value: { code: "513130", label: "Book Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513140": {
      value: { code: "513140", label: "Directory and Mailing List Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513191": {
      value: { code: "513191", label: "Greeting Card Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513199": {
      value: { code: "513199", label: "All Other Publishers" },
      industry: "Information",
      subcategory: "Newspaper, Periodical, Book, and Directory Publishers"
    },
    "513210": {
      value: { code: "513210", label: "Software Publishers" },
      industry: "Information",
      subcategory: "Software Publishers"
    },
    "516110": {
      value: { code: "516110", label: "Radio Broadcasting Stations" },
      industry: "Information",
      subcategory: "Radio and Television Broadcasting Stations"
    },
    "516120": {
      value: { code: "516120", label: "Television Broadcasting Stations" },
      industry: "Information",
      subcategory: "Radio and Television Broadcasting Stations"
    },
    "516210": {
      value: {
        code: "516210",
        label: "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers"
      },
      industry: "Information",
      subcategory: "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers"
    },
    "517111": {
      value: { code: "517111", label: "Wired Telecommunications Carriers" },
      industry: "Information",
      subcategory: "Wired and Wireless Telecommunications (except Satellite)"
    },
    "517112": {
      value: {
        code: "517112",
        label: "Wireless Telecommunications Carriers (except Satellite)"
      },
      industry: "Information",
      subcategory: "Wired and Wireless Telecommunications (except Satellite)"
    },
    "517121": {
      value: { code: "517121", label: "Telecommunications Resellers" },
      industry: "Information",
      subcategory: "Wired and Wireless Telecommunications (except Satellite)"
    },
    "517122": {
      value: {
        code: "517122",
        label: "Agents for Wireless Telecommunications Services"
      },
      industry: "Information",
      subcategory: "Wired and Wireless Telecommunications (except Satellite)"
    },
    "517410": {
      value: { code: "517410", label: "Satellite Telecommunications" },
      industry: "Information",
      subcategory: "Satellite Telecommunications"
    },
    "517810": {
      value: { code: "517810", label: "All Other Telecommunications" },
      industry: "Information",
      subcategory: "All Other Telecommunications"
    },
    "518210": {
      value: {
        code: "518210",
        label: "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services"
      },
      industry: "Information",
      subcategory: "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services"
    },
    "519210": {
      value: { code: "519210", label: "Libraries and Archives" },
      industry: "Information",
      subcategory: "Web Search Portals, Libraries, Archives, and Other Information Services"
    },
    "519290": {
      value: {
        code: "519290",
        label: "Web Search Portals and All Other Information Services"
      },
      industry: "Information",
      subcategory: "Web Search Portals, Libraries, Archives, and Other Information Services"
    },
    "521110": {
      value: { code: "521110", label: "Monetary Authorities-Central Bank" },
      industry: "Finance and Insurance",
      subcategory: "Monetary Authorities-Central Bank"
    },
    "522110": {
      value: { code: "522110", label: "Commercial Banking" },
      industry: "Finance and Insurance",
      subcategory: "Depository Credit Intermediation"
    },
    "522130": {
      value: { code: "522130", label: "Credit Unions" },
      industry: "Finance and Insurance",
      subcategory: "Depository Credit Intermediation"
    },
    "522180": {
      value: {
        code: "522180",
        label: "Savings Institutions and Other Depository Credit Intermediation"
      },
      industry: "Finance and Insurance",
      subcategory: "Depository Credit Intermediation"
    },
    "522210": {
      value: { code: "522210", label: "Credit Card Issuing" },
      industry: "Finance and Insurance",
      subcategory: "Nondepository Credit Intermediation"
    },
    "522220": {
      value: { code: "522220", label: "Sales Financing" },
      industry: "Finance and Insurance",
      subcategory: "Nondepository Credit Intermediation"
    },
    "522291": {
      value: { code: "522291", label: "Consumer Lending" },
      industry: "Finance and Insurance",
      subcategory: "Nondepository Credit Intermediation"
    },
    "522292": {
      value: { code: "522292", label: "Real Estate Credit" },
      industry: "Finance and Insurance",
      subcategory: "Nondepository Credit Intermediation"
    },
    "522299": {
      value: {
        code: "522299",
        label: "International, Secondary Market, and All Other Nondepository Credit Intermediation"
      },
      industry: "Finance and Insurance",
      subcategory: "Nondepository Credit Intermediation"
    },
    "522310": {
      value: { code: "522310", label: "Mortgage and Nonmortgage Loan Brokers" },
      industry: "Finance and Insurance",
      subcategory: "Activities Related to Credit Intermediation"
    },
    "522320": {
      value: {
        code: "522320",
        label: "Financial Transactions Processing, Reserve, and Clearinghouse Activities"
      },
      industry: "Finance and Insurance",
      subcategory: "Activities Related to Credit Intermediation"
    },
    "522390": {
      value: {
        code: "522390",
        label: "Other Activities Related to Credit Intermediation"
      },
      industry: "Finance and Insurance",
      subcategory: "Activities Related to Credit Intermediation"
    },
    "523150": {
      value: {
        code: "523150",
        label: "Investment Banking and Securities Intermediation"
      },
      industry: "Finance and Insurance",
      subcategory: "Securities and Commodity Contracts Intermediation and Brokerage"
    },
    "523160": {
      value: { code: "523160", label: "Commodity Contracts Intermediation" },
      industry: "Finance and Insurance",
      subcategory: "Securities and Commodity Contracts Intermediation and Brokerage"
    },
    "523210": {
      value: { code: "523210", label: "Securities and Commodity Exchanges" },
      industry: "Finance and Insurance",
      subcategory: "Securities and Commodity Exchanges"
    },
    "523910": {
      value: { code: "523910", label: "Miscellaneous Intermediation" },
      industry: "Finance and Insurance",
      subcategory: "Other Financial Investment Activities"
    },
    "523940": {
      value: {
        code: "523940",
        label: "Portfolio Management and Investment Advice"
      },
      industry: "Finance and Insurance",
      subcategory: "Other Financial Investment Activities"
    },
    "523991": {
      value: {
        code: "523991",
        label: "Trust, Fiduciary, and Custody Activities"
      },
      industry: "Finance and Insurance",
      subcategory: "Other Financial Investment Activities"
    },
    "523999": {
      value: {
        code: "523999",
        label: "Miscellaneous Financial Investment Activities"
      },
      industry: "Finance and Insurance",
      subcategory: "Other Financial Investment Activities"
    },
    "524113": {
      value: { code: "524113", label: "Direct Life Insurance Carriers" },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524114": {
      value: {
        code: "524114",
        label: "Direct Health and Medical Insurance Carriers"
      },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524126": {
      value: {
        code: "524126",
        label: "Direct Property and Casualty Insurance Carriers"
      },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524127": {
      value: { code: "524127", label: "Direct Title Insurance Carriers" },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524128": {
      value: {
        code: "524128",
        label: "Other Direct Insurance (except Life, Health, and Medical) Carriers"
      },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524130": {
      value: { code: "524130", label: "Reinsurance Carriers" },
      industry: "Finance and Insurance",
      subcategory: "Insurance Carriers"
    },
    "524210": {
      value: { code: "524210", label: "Insurance Agencies and Brokerages" },
      industry: "Finance and Insurance",
      subcategory: "Agencies, Brokerages, and Other Insurance Related Activities"
    },
    "524291": {
      value: { code: "524291", label: "Claims Adjusting" },
      industry: "Finance and Insurance",
      subcategory: "Agencies, Brokerages, and Other Insurance Related Activities"
    },
    "524292": {
      value: {
        code: "524292",
        label: "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds"
      },
      industry: "Finance and Insurance",
      subcategory: "Agencies, Brokerages, and Other Insurance Related Activities"
    },
    "524298": {
      value: { code: "524298", label: "All Other Insurance Related Activities" },
      industry: "Finance and Insurance",
      subcategory: "Agencies, Brokerages, and Other Insurance Related Activities"
    },
    "525110": {
      value: { code: "525110", label: "Pension Funds" },
      industry: "Finance and Insurance",
      subcategory: "Insurance and Employee Benefit Funds"
    },
    "525120": {
      value: { code: "525120", label: "Health and Welfare Funds" },
      industry: "Finance and Insurance",
      subcategory: "Insurance and Employee Benefit Funds"
    },
    "525190": {
      value: { code: "525190", label: "Other Insurance Funds" },
      industry: "Finance and Insurance",
      subcategory: "Insurance and Employee Benefit Funds"
    },
    "525910": {
      value: { code: "525910", label: "Open-End Investment Funds" },
      industry: "Finance and Insurance",
      subcategory: "Other Investment Pools and Funds"
    },
    "525920": {
      value: { code: "525920", label: "Trusts, Estates, and Agency Accounts" },
      industry: "Finance and Insurance",
      subcategory: "Other Investment Pools and Funds"
    },
    "525990": {
      value: { code: "525990", label: "Other Financial Vehicles" },
      industry: "Finance and Insurance",
      subcategory: "Other Investment Pools and Funds"
    },
    "531110": {
      value: {
        code: "531110",
        label: "Lessors of Residential Buildings and Dwellings"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Lessors of Real Estate"
    },
    "531120": {
      value: {
        code: "531120",
        label: "Lessors of Nonresidential Buildings (except Miniwarehouses)"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Lessors of Real Estate"
    },
    "531130": {
      value: {
        code: "531130",
        label: "Lessors of Miniwarehouses and Self-Storage Units"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Lessors of Real Estate"
    },
    "531190": {
      value: { code: "531190", label: "Lessors of Other Real Estate Property" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Lessors of Real Estate"
    },
    "531210": {
      value: {
        code: "531210",
        label: "Offices of Real Estate Agents and Brokers"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Offices of Real Estate Agents and Brokers"
    },
    "531311": {
      value: { code: "531311", label: "Residential Property Managers" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Activities Related to Real Estate"
    },
    "531312": {
      value: { code: "531312", label: "Nonresidential Property Managers" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Activities Related to Real Estate"
    },
    "531320": {
      value: { code: "531320", label: "Offices of Real Estate Appraisers" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Activities Related to Real Estate"
    },
    "531390": {
      value: {
        code: "531390",
        label: "Other Activities Related to Real Estate"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Activities Related to Real Estate"
    },
    "532111": {
      value: { code: "532111", label: "Passenger Car Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Automotive Equipment Rental and Leasing"
    },
    "532112": {
      value: { code: "532112", label: "Passenger Car Leasing" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Automotive Equipment Rental and Leasing"
    },
    "532120": {
      value: {
        code: "532120",
        label: "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Automotive Equipment Rental and Leasing"
    },
    "532210": {
      value: {
        code: "532210",
        label: "Consumer Electronics and Appliances Rental"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532281": {
      value: { code: "532281", label: "Formal Wear and Costume Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532282": {
      value: { code: "532282", label: "Video Tape and Disc Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532283": {
      value: { code: "532283", label: "Home Health Equipment Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532284": {
      value: { code: "532284", label: "Recreational Goods Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532289": {
      value: { code: "532289", label: "All Other Consumer Goods Rental" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Consumer Goods Rental"
    },
    "532310": {
      value: { code: "532310", label: "General Rental Centers" },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "General Rental Centers"
    },
    "532411": {
      value: {
        code: "532411",
        label: "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Commercial and Industrial Machinery and Equipment Rental and Leasing"
    },
    "532412": {
      value: {
        code: "532412",
        label: "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Commercial and Industrial Machinery and Equipment Rental and Leasing"
    },
    "532420": {
      value: {
        code: "532420",
        label: "Office Machinery and Equipment Rental and Leasing"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Commercial and Industrial Machinery and Equipment Rental and Leasing"
    },
    "532490": {
      value: {
        code: "532490",
        label: "Other Commercial and Industrial Machinery and Equipment Rental and Leasing"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Commercial and Industrial Machinery and Equipment Rental and Leasing"
    },
    "533110": {
      value: {
        code: "533110",
        label: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)"
      },
      industry: "Real Estate and Rental and Leasing",
      subcategory: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)"
    },
    "541110": {
      value: { code: "541110", label: "Offices of Lawyers" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Legal Services"
    },
    "541120": {
      value: { code: "541120", label: "Offices of Notaries" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Legal Services"
    },
    "541191": {
      value: { code: "541191", label: "Title Abstract and Settlement Offices" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Legal Services"
    },
    "541199": {
      value: { code: "541199", label: "All Other Legal Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Legal Services"
    },
    "541211": {
      value: {
        code: "541211",
        label: "Offices of Certified Public Accountants"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Accounting, Tax Preparation, Bookkeeping, and Payroll Services"
    },
    "541213": {
      value: { code: "541213", label: "Tax Preparation Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Accounting, Tax Preparation, Bookkeeping, and Payroll Services"
    },
    "541214": {
      value: { code: "541214", label: "Payroll Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Accounting, Tax Preparation, Bookkeeping, and Payroll Services"
    },
    "541219": {
      value: { code: "541219", label: "Other Accounting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Accounting, Tax Preparation, Bookkeeping, and Payroll Services"
    },
    "541310": {
      value: { code: "541310", label: "Architectural Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541320": {
      value: { code: "541320", label: "Landscape Architectural Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541330": {
      value: { code: "541330", label: "Engineering Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541340": {
      value: { code: "541340", label: "Drafting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541350": {
      value: { code: "541350", label: "Building Inspection Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541360": {
      value: {
        code: "541360",
        label: "Geophysical Surveying and Mapping Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541370": {
      value: {
        code: "541370",
        label: "Surveying and Mapping (except Geophysical) Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541380": {
      value: { code: "541380", label: "Testing Laboratories and Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Architectural, Engineering, and Related Services"
    },
    "541410": {
      value: { code: "541410", label: "Interior Design Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Specialized Design Services"
    },
    "541420": {
      value: { code: "541420", label: "Industrial Design Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Specialized Design Services"
    },
    "541430": {
      value: { code: "541430", label: "Graphic Design Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Specialized Design Services"
    },
    "541490": {
      value: { code: "541490", label: "Other Specialized Design Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Specialized Design Services"
    },
    "541511": {
      value: { code: "541511", label: "Custom Computer Programming Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Computer Systems Design and Related Services"
    },
    "541512": {
      value: { code: "541512", label: "Computer Systems Design Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Computer Systems Design and Related Services"
    },
    "541513": {
      value: {
        code: "541513",
        label: "Computer Facilities Management Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Computer Systems Design and Related Services"
    },
    "541519": {
      value: { code: "541519", label: "Other Computer Related Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Computer Systems Design and Related Services"
    },
    "541611": {
      value: {
        code: "541611",
        label: "Administrative Management and General Management Consulting Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541612": {
      value: { code: "541612", label: "Human Resources Consulting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541613": {
      value: { code: "541613", label: "Marketing Consulting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541614": {
      value: {
        code: "541614",
        label: "Process, Physical Distribution, and Logistics Consulting Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541618": {
      value: { code: "541618", label: "Other Management Consulting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541620": {
      value: { code: "541620", label: "Environmental Consulting Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541690": {
      value: {
        code: "541690",
        label: "Other Scientific and Technical Consulting Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Management, Scientific, and Technical Consulting Services"
    },
    "541713": {
      value: {
        code: "541713",
        label: "Research and Development in Nanotechnology"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Scientific Research and Development Services"
    },
    "541714": {
      value: {
        code: "541714",
        label: "Research and Development in Biotechnology (except Nanobiotechnology)"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Scientific Research and Development Services"
    },
    "541715": {
      value: {
        code: "541715",
        label: "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Scientific Research and Development Services"
    },
    "541720": {
      value: {
        code: "541720",
        label: "Research and Development in the Social Sciences and Humanities"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Scientific Research and Development Services"
    },
    "541810": {
      value: { code: "541810", label: "Advertising Agencies" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541820": {
      value: { code: "541820", label: "Public Relations Agencies" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541830": {
      value: { code: "541830", label: "Media Buying Agencies" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541840": {
      value: { code: "541840", label: "Media Representatives" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541850": {
      value: { code: "541850", label: "Indoor and Outdoor Display Advertising" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541860": {
      value: { code: "541860", label: "Direct Mail Advertising" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541870": {
      value: {
        code: "541870",
        label: "Advertising Material Distribution Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541890": {
      value: { code: "541890", label: "Other Services Related to Advertising" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Advertising, Public Relations, and Related Services"
    },
    "541910": {
      value: {
        code: "541910",
        label: "Marketing Research and Public Opinion Polling"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "541921": {
      value: { code: "541921", label: "Photography Studios, Portrait" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "541922": {
      value: { code: "541922", label: "Commercial Photography" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "541930": {
      value: {
        code: "541930",
        label: "Translation and Interpretation Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "541940": {
      value: { code: "541940", label: "Veterinary Services" },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "541990": {
      value: {
        code: "541990",
        label: "All Other Professional, Scientific, and Technical Services"
      },
      industry: "Professional, Scientific, and Technical Services",
      subcategory: "Other Professional, Scientific, and Technical Services"
    },
    "551111": {
      value: { code: "551111", label: "Offices of Bank Holding Companies" },
      industry: "Management of Companies and Enterprises",
      subcategory: "Management of Companies and Enterprises"
    },
    "551112": {
      value: { code: "551112", label: "Offices of Other Holding Companies" },
      industry: "Management of Companies and Enterprises",
      subcategory: "Management of Companies and Enterprises"
    },
    "551114": {
      value: {
        code: "551114",
        label: "Corporate, Subsidiary, and Regional Managing Offices"
      },
      industry: "Management of Companies and Enterprises",
      subcategory: "Management of Companies and Enterprises"
    },
    "561110": {
      value: { code: "561110", label: "Office Administrative Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Office Administrative Services"
    },
    "561210": {
      value: { code: "561210", label: "Facilities Support Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Facilities Support Services"
    },
    "561311": {
      value: { code: "561311", label: "Employment Placement Agencies" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Employment Services"
    },
    "561312": {
      value: { code: "561312", label: "Executive Search Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Employment Services"
    },
    "561320": {
      value: { code: "561320", label: "Temporary Help Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Employment Services"
    },
    "561330": {
      value: { code: "561330", label: "Professional Employer Organizations" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Employment Services"
    },
    "561410": {
      value: { code: "561410", label: "Document Preparation Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561421": {
      value: { code: "561421", label: "Telephone Answering Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561422": {
      value: {
        code: "561422",
        label: "Telemarketing Bureaus and Other Contact Centers"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561431": {
      value: { code: "561431", label: "Private Mail Centers" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561439": {
      value: {
        code: "561439",
        label: "Other Business Service Centers (including Copy Shops)"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561440": {
      value: { code: "561440", label: "Collection Agencies" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561450": {
      value: { code: "561450", label: "Credit Bureaus" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561491": {
      value: { code: "561491", label: "Repossession Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561492": {
      value: { code: "561492", label: "Court Reporting and Stenotype Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561499": {
      value: { code: "561499", label: "All Other Business Support Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Business Support Services"
    },
    "561510": {
      value: { code: "561510", label: "Travel Agencies" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Travel Arrangement and Reservation Services"
    },
    "561520": {
      value: { code: "561520", label: "Tour Operators" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Travel Arrangement and Reservation Services"
    },
    "561591": {
      value: { code: "561591", label: "Convention and Visitors Bureaus" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Travel Arrangement and Reservation Services"
    },
    "561599": {
      value: {
        code: "561599",
        label: "All Other Travel Arrangement and Reservation Services"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Travel Arrangement and Reservation Services"
    },
    "561611": {
      value: {
        code: "561611",
        label: "Investigation and Personal Background Check Services"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Investigation and Security Services"
    },
    "561612": {
      value: { code: "561612", label: "Security Guards and Patrol Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Investigation and Security Services"
    },
    "561613": {
      value: { code: "561613", label: "Armored Car Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Investigation and Security Services"
    },
    "561621": {
      value: {
        code: "561621",
        label: "Security Systems Services (except Locksmiths)"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Investigation and Security Services"
    },
    "561622": {
      value: { code: "561622", label: "Locksmiths" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Investigation and Security Services"
    },
    "561710": {
      value: {
        code: "561710",
        label: "Exterminating and Pest Control Services"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Services to Buildings and Dwellings"
    },
    "561720": {
      value: { code: "561720", label: "Janitorial Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Services to Buildings and Dwellings"
    },
    "561730": {
      value: { code: "561730", label: "Landscaping Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Services to Buildings and Dwellings"
    },
    "561740": {
      value: {
        code: "561740",
        label: "Carpet and Upholstery Cleaning Services"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Services to Buildings and Dwellings"
    },
    "561790": {
      value: {
        code: "561790",
        label: "Other Services to Buildings and Dwellings"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Services to Buildings and Dwellings"
    },
    "561910": {
      value: { code: "561910", label: "Packaging and Labeling Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Other Support Services"
    },
    "561920": {
      value: { code: "561920", label: "Convention and Trade Show Organizers" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Other Support Services"
    },
    "561990": {
      value: { code: "561990", label: "All Other Support Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Other Support Services"
    },
    "562111": {
      value: { code: "562111", label: "Solid Waste Collection" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Collection"
    },
    "562112": {
      value: { code: "562112", label: "Hazardous Waste Collection" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Collection"
    },
    "562119": {
      value: { code: "562119", label: "Other Waste Collection" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Collection"
    },
    "562211": {
      value: { code: "562211", label: "Hazardous Waste Treatment and Disposal" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Treatment and Disposal"
    },
    "562212": {
      value: { code: "562212", label: "Solid Waste Landfill" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Treatment and Disposal"
    },
    "562213": {
      value: {
        code: "562213",
        label: "Solid Waste Combustors and Incinerators"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Treatment and Disposal"
    },
    "562219": {
      value: {
        code: "562219",
        label: "Other Nonhazardous Waste Treatment and Disposal"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Waste Treatment and Disposal"
    },
    "562910": {
      value: { code: "562910", label: "Remediation Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Remediation and Other Waste Management Services"
    },
    "562920": {
      value: { code: "562920", label: "Materials Recovery Facilities" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Remediation and Other Waste Management Services"
    },
    "562991": {
      value: { code: "562991", label: "Septic Tank and Related Services" },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Remediation and Other Waste Management Services"
    },
    "562998": {
      value: {
        code: "562998",
        label: "All Other Miscellaneous Waste Management Services"
      },
      industry: "Administrative and Support and Waste Management and Remediation Services",
      subcategory: "Remediation and Other Waste Management Services"
    },
    "611110": {
      value: { code: "611110", label: "Elementary and Secondary Schools" },
      industry: "Educational Services",
      subcategory: "Elementary and Secondary Schools"
    },
    "611210": {
      value: { code: "611210", label: "Junior Colleges" },
      industry: "Educational Services",
      subcategory: "Junior Colleges"
    },
    "611310": {
      value: {
        code: "611310",
        label: "Colleges, Universities, and Professional Schools"
      },
      industry: "Educational Services",
      subcategory: "Colleges, Universities, and Professional Schools"
    },
    "611410": {
      value: { code: "611410", label: "Business and Secretarial Schools" },
      industry: "Educational Services",
      subcategory: "Business Schools and Computer and Management Training"
    },
    "611420": {
      value: { code: "611420", label: "Computer Training" },
      industry: "Educational Services",
      subcategory: "Business Schools and Computer and Management Training"
    },
    "611430": {
      value: {
        code: "611430",
        label: "Professional and Management Development Training"
      },
      industry: "Educational Services",
      subcategory: "Business Schools and Computer and Management Training"
    },
    "611511": {
      value: { code: "611511", label: "Cosmetology and Barber Schools" },
      industry: "Educational Services",
      subcategory: "Technical and Trade Schools"
    },
    "611512": {
      value: { code: "611512", label: "Flight Training" },
      industry: "Educational Services",
      subcategory: "Technical and Trade Schools"
    },
    "611513": {
      value: { code: "611513", label: "Apprenticeship Training" },
      industry: "Educational Services",
      subcategory: "Technical and Trade Schools"
    },
    "611519": {
      value: { code: "611519", label: "Other Technical and Trade Schools" },
      industry: "Educational Services",
      subcategory: "Technical and Trade Schools"
    },
    "611610": {
      value: { code: "611610", label: "Fine Arts Schools" },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611620": {
      value: { code: "611620", label: "Sports and Recreation Instruction" },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611630": {
      value: { code: "611630", label: "Language Schools" },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611691": {
      value: { code: "611691", label: "Exam Preparation and Tutoring" },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611692": {
      value: { code: "611692", label: "Automobile Driving Schools" },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611699": {
      value: {
        code: "611699",
        label: "All Other Miscellaneous Schools and Instruction"
      },
      industry: "Educational Services",
      subcategory: "Other Schools and Instruction"
    },
    "611710": {
      value: { code: "611710", label: "Educational Support Services" },
      industry: "Educational Services",
      subcategory: "Educational Support Services"
    },
    "621111": {
      value: {
        code: "621111",
        label: "Offices of Physicians (except Mental Health Specialists)"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Physicians"
    },
    "621112": {
      value: {
        code: "621112",
        label: "Offices of Physicians, Mental Health Specialists"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Physicians"
    },
    "621210": {
      value: { code: "621210", label: "Offices of Dentists" },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Dentists"
    },
    "621310": {
      value: { code: "621310", label: "Offices of Chiropractors" },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621320": {
      value: { code: "621320", label: "Offices of Optometrists" },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621330": {
      value: {
        code: "621330",
        label: "Offices of Mental Health Practitioners (except Physicians)"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621340": {
      value: {
        code: "621340",
        label: "Offices of Physical, Occupational and Speech Therapists, and Audiologists"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621391": {
      value: { code: "621391", label: "Offices of Podiatrists" },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621399": {
      value: {
        code: "621399",
        label: "Offices of All Other Miscellaneous Health Practitioners"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Offices of Other Health Practitioners"
    },
    "621410": {
      value: { code: "621410", label: "Family Planning Centers" },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621420": {
      value: {
        code: "621420",
        label: "Outpatient Mental Health and Substance Abuse Centers"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621491": {
      value: { code: "621491", label: "HMO Medical Centers" },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621492": {
      value: { code: "621492", label: "Kidney Dialysis Centers" },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621493": {
      value: {
        code: "621493",
        label: "Freestanding Ambulatory Surgical and Emergency Centers"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621498": {
      value: { code: "621498", label: "All Other Outpatient Care Centers" },
      industry: "Health Care and Social Assistance",
      subcategory: "Outpatient Care Centers"
    },
    "621511": {
      value: { code: "621511", label: "Medical Laboratories" },
      industry: "Health Care and Social Assistance",
      subcategory: "Medical and Diagnostic Laboratories"
    },
    "621512": {
      value: { code: "621512", label: "Diagnostic Imaging Centers" },
      industry: "Health Care and Social Assistance",
      subcategory: "Medical and Diagnostic Laboratories"
    },
    "621610": {
      value: { code: "621610", label: "Home Health Care Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Home Health Care Services"
    },
    "621910": {
      value: { code: "621910", label: "Ambulance Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Other Ambulatory Health Care Services"
    },
    "621991": {
      value: { code: "621991", label: "Blood and Organ Banks" },
      industry: "Health Care and Social Assistance",
      subcategory: "Other Ambulatory Health Care Services"
    },
    "621999": {
      value: {
        code: "621999",
        label: "All Other Miscellaneous Ambulatory Health Care Services"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Other Ambulatory Health Care Services"
    },
    "622110": {
      value: { code: "622110", label: "General Medical and Surgical Hospitals" },
      industry: "Health Care and Social Assistance",
      subcategory: "General Medical and Surgical Hospitals"
    },
    "622210": {
      value: {
        code: "622210",
        label: "Psychiatric and Substance Abuse Hospitals"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Psychiatric and Substance Abuse Hospitals"
    },
    "622310": {
      value: {
        code: "622310",
        label: "Specialty (except Psychiatric and Substance Abuse) Hospitals"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Specialty (except Psychiatric and Substance Abuse) Hospitals"
    },
    "623110": {
      value: {
        code: "623110",
        label: "Nursing Care Facilities (Skilled Nursing Facilities)"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Nursing Care Facilities (Skilled Nursing Facilities)"
    },
    "623210": {
      value: {
        code: "623210",
        label: "Residential Intellectual and Developmental Disability Facilities"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities"
    },
    "623220": {
      value: {
        code: "623220",
        label: "Residential Mental Health and Substance Abuse Facilities"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities"
    },
    "623311": {
      value: { code: "623311", label: "Continuing Care Retirement Communities" },
      industry: "Health Care and Social Assistance",
      subcategory: "Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly"
    },
    "623312": {
      value: {
        code: "623312",
        label: "Assisted Living Facilities for the Elderly"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly"
    },
    "623990": {
      value: { code: "623990", label: "Other Residential Care Facilities" },
      industry: "Health Care and Social Assistance",
      subcategory: "Other Residential Care Facilities"
    },
    "624110": {
      value: { code: "624110", label: "Child and Youth Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Individual and Family Services"
    },
    "624120": {
      value: {
        code: "624120",
        label: "Services for the Elderly and Persons with Disabilities"
      },
      industry: "Health Care and Social Assistance",
      subcategory: "Individual and Family Services"
    },
    "624190": {
      value: { code: "624190", label: "Other Individual and Family Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Individual and Family Services"
    },
    "624210": {
      value: { code: "624210", label: "Community Food Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Community Food and Housing, and Emergency and Other Relief Services"
    },
    "624221": {
      value: { code: "624221", label: "Temporary Shelters" },
      industry: "Health Care and Social Assistance",
      subcategory: "Community Food and Housing, and Emergency and Other Relief Services"
    },
    "624229": {
      value: { code: "624229", label: "Other Community Housing Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Community Food and Housing, and Emergency and Other Relief Services"
    },
    "624230": {
      value: { code: "624230", label: "Emergency and Other Relief Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Community Food and Housing, and Emergency and Other Relief Services"
    },
    "624310": {
      value: { code: "624310", label: "Vocational Rehabilitation Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Vocational Rehabilitation Services"
    },
    "624410": {
      value: { code: "624410", label: "Child Care Services" },
      industry: "Health Care and Social Assistance",
      subcategory: "Child Care Services"
    },
    "711110": {
      value: { code: "711110", label: "Theater Companies and Dinner Theaters" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Performing Arts Companies"
    },
    "711120": {
      value: { code: "711120", label: "Dance Companies" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Performing Arts Companies"
    },
    "711130": {
      value: { code: "711130", label: "Musical Groups and Artists" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Performing Arts Companies"
    },
    "711190": {
      value: { code: "711190", label: "Other Performing Arts Companies" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Performing Arts Companies"
    },
    "711211": {
      value: { code: "711211", label: "Sports Teams and Clubs" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Spectator Sports"
    },
    "711212": {
      value: { code: "711212", label: "Racetracks" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Spectator Sports"
    },
    "711219": {
      value: { code: "711219", label: "Other Spectator Sports" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Spectator Sports"
    },
    "711310": {
      value: {
        code: "711310",
        label: "Promoters of Performing Arts, Sports, and Similar Events with Facilities"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Promoters of Performing Arts, Sports, and Similar Events"
    },
    "711320": {
      value: {
        code: "711320",
        label: "Promoters of Performing Arts, Sports, and Similar Events without Facilities"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Promoters of Performing Arts, Sports, and Similar Events"
    },
    "711410": {
      value: {
        code: "711410",
        label: "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures"
    },
    "711510": {
      value: {
        code: "711510",
        label: "Independent Artists, Writers, and Performers"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Independent Artists, Writers, and Performers"
    },
    "712110": {
      value: { code: "712110", label: "Museums" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Museums, Historical Sites, and Similar Institutions"
    },
    "712120": {
      value: { code: "712120", label: "Historical Sites" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Museums, Historical Sites, and Similar Institutions"
    },
    "712130": {
      value: { code: "712130", label: "Zoos and Botanical Gardens" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Museums, Historical Sites, and Similar Institutions"
    },
    "712190": {
      value: {
        code: "712190",
        label: "Nature Parks and Other Similar Institutions"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Museums, Historical Sites, and Similar Institutions"
    },
    "713110": {
      value: { code: "713110", label: "Amusement and Theme Parks" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Amusement Parks and Arcades"
    },
    "713120": {
      value: { code: "713120", label: "Amusement Arcades" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Amusement Parks and Arcades"
    },
    "713210": {
      value: { code: "713210", label: "Casinos (except Casino Hotels)" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Gambling Industries"
    },
    "713290": {
      value: { code: "713290", label: "Other Gambling Industries" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Gambling Industries"
    },
    "713910": {
      value: { code: "713910", label: "Golf Courses and Country Clubs" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "713920": {
      value: { code: "713920", label: "Skiing Facilities" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "713930": {
      value: { code: "713930", label: "Marinas" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "713940": {
      value: {
        code: "713940",
        label: "Fitness and Recreational Sports Centers"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "713950": {
      value: { code: "713950", label: "Bowling Centers" },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "713990": {
      value: {
        code: "713990",
        label: "All Other Amusement and Recreation Industries"
      },
      industry: "Arts, Entertainment, and Recreation",
      subcategory: "Other Amusement and Recreation Industries"
    },
    "721110": {
      value: {
        code: "721110",
        label: "Hotels (except Casino Hotels) and Motels"
      },
      industry: "Accommodation and Food Services",
      subcategory: "Traveler Accommodation"
    },
    "721120": {
      value: { code: "721120", label: "Casino Hotels" },
      industry: "Accommodation and Food Services",
      subcategory: "Traveler Accommodation"
    },
    "721191": {
      value: { code: "721191", label: "Bed-and-Breakfast Inns" },
      industry: "Accommodation and Food Services",
      subcategory: "Traveler Accommodation"
    },
    "721199": {
      value: { code: "721199", label: "All Other Traveler Accommodation" },
      industry: "Accommodation and Food Services",
      subcategory: "Traveler Accommodation"
    },
    "721211": {
      value: {
        code: "721211",
        label: "RV (Recreational Vehicle) Parks and Campgrounds"
      },
      industry: "Accommodation and Food Services",
      subcategory: "RV (Recreational Vehicle) Parks and Recreational Camps"
    },
    "721214": {
      value: {
        code: "721214",
        label: "Recreational and Vacation Camps (except Campgrounds)"
      },
      industry: "Accommodation and Food Services",
      subcategory: "RV (Recreational Vehicle) Parks and Recreational Camps"
    },
    "721310": {
      value: {
        code: "721310",
        label: "Rooming and Boarding Houses, Dormitories, and Workers' Camps"
      },
      industry: "Accommodation and Food Services",
      subcategory: "Rooming and Boarding Houses, Dormitories, and Workers' Camps"
    },
    "722310": {
      value: { code: "722310", label: "Food Service Contractors" },
      industry: "Accommodation and Food Services",
      subcategory: "Special Food Services"
    },
    "722320": {
      value: { code: "722320", label: "Caterers" },
      industry: "Accommodation and Food Services",
      subcategory: "Special Food Services"
    },
    "722330": {
      value: { code: "722330", label: "Mobile Food Services" },
      industry: "Accommodation and Food Services",
      subcategory: "Special Food Services"
    },
    "722410": {
      value: { code: "722410", label: "Drinking Places (Alcoholic Beverages)" },
      industry: "Accommodation and Food Services",
      subcategory: "Drinking Places (Alcoholic Beverages)"
    },
    "722511": {
      value: { code: "722511", label: "Full-Service Restaurants" },
      industry: "Accommodation and Food Services",
      subcategory: "Restaurants and Other Eating Places"
    },
    "722513": {
      value: { code: "722513", label: "Limited-Service Restaurants" },
      industry: "Accommodation and Food Services",
      subcategory: "Restaurants and Other Eating Places"
    },
    "722514": {
      value: { code: "722514", label: "Cafeterias, Grill Buffets, and Buffets" },
      industry: "Accommodation and Food Services",
      subcategory: "Restaurants and Other Eating Places"
    },
    "722515": {
      value: { code: "722515", label: "Snack and Nonalcoholic Beverage Bars" },
      industry: "Accommodation and Food Services",
      subcategory: "Restaurants and Other Eating Places"
    },
    "811111": {
      value: { code: "811111", label: "General Automotive Repair" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811114": {
      value: { code: "811114", label: "Specialized Automotive Repair" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811121": {
      value: {
        code: "811121",
        label: "Automotive Body, Paint, and Interior Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811122": {
      value: { code: "811122", label: "Automotive Glass Replacement Shops" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811191": {
      value: {
        code: "811191",
        label: "Automotive Oil Change and Lubrication Shops"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811192": {
      value: { code: "811192", label: "Car Washes" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811198": {
      value: {
        code: "811198",
        label: "All Other Automotive Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Automotive Repair and Maintenance"
    },
    "811210": {
      value: {
        code: "811210",
        label: "Electronic and Precision Equipment Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Electronic and Precision Equipment Repair and Maintenance"
    },
    "811310": {
      value: {
        code: "811310",
        label: "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance"
    },
    "811411": {
      value: {
        code: "811411",
        label: "Home and Garden Equipment Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal and Household Goods Repair and Maintenance"
    },
    "811412": {
      value: { code: "811412", label: "Appliance Repair and Maintenance" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal and Household Goods Repair and Maintenance"
    },
    "811420": {
      value: { code: "811420", label: "Reupholstery and Furniture Repair" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal and Household Goods Repair and Maintenance"
    },
    "811430": {
      value: { code: "811430", label: "Footwear and Leather Goods Repair" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal and Household Goods Repair and Maintenance"
    },
    "811490": {
      value: {
        code: "811490",
        label: "Other Personal and Household Goods Repair and Maintenance"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal and Household Goods Repair and Maintenance"
    },
    "812111": {
      value: { code: "812111", label: "Barber Shops" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal Care Services"
    },
    "812112": {
      value: { code: "812112", label: "Beauty Salons" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal Care Services"
    },
    "812113": {
      value: { code: "812113", label: "Nail Salons" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal Care Services"
    },
    "812191": {
      value: { code: "812191", label: "Diet and Weight Reducing Centers" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal Care Services"
    },
    "812199": {
      value: { code: "812199", label: "Other Personal Care Services" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Personal Care Services"
    },
    "812210": {
      value: { code: "812210", label: "Funeral Homes and Funeral Services" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Death Care Services"
    },
    "812220": {
      value: { code: "812220", label: "Cemeteries and Crematories" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Death Care Services"
    },
    "812310": {
      value: {
        code: "812310",
        label: "Coin-Operated Laundries and Drycleaners"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Drycleaning and Laundry Services"
    },
    "812320": {
      value: {
        code: "812320",
        label: "Drycleaning and Laundry Services (except Coin-Operated)"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Drycleaning and Laundry Services"
    },
    "812331": {
      value: { code: "812331", label: "Linen Supply" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Drycleaning and Laundry Services"
    },
    "812332": {
      value: { code: "812332", label: "Industrial Launderers" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Drycleaning and Laundry Services"
    },
    "812910": {
      value: { code: "812910", label: "Pet Care (except Veterinary) Services" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Other Personal Services"
    },
    "812921": {
      value: {
        code: "812921",
        label: "Photofinishing Laboratories (except One-Hour)"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Other Personal Services"
    },
    "812922": {
      value: { code: "812922", label: "One-Hour Photofinishing" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Other Personal Services"
    },
    "812930": {
      value: { code: "812930", label: "Parking Lots and Garages" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Other Personal Services"
    },
    "812990": {
      value: { code: "812990", label: "All Other Personal Services" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Other Personal Services"
    },
    "813110": {
      value: { code: "813110", label: "Religious Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Religious Organizations"
    },
    "813211": {
      value: { code: "813211", label: "Grantmaking Foundations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Grantmaking and Giving Services"
    },
    "813212": {
      value: { code: "813212", label: "Voluntary Health Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Grantmaking and Giving Services"
    },
    "813219": {
      value: { code: "813219", label: "Other Grantmaking and Giving Services" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Grantmaking and Giving Services"
    },
    "813311": {
      value: { code: "813311", label: "Human Rights Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Social Advocacy Organizations"
    },
    "813312": {
      value: {
        code: "813312",
        label: "Environment, Conservation and Wildlife Organizations"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Social Advocacy Organizations"
    },
    "813319": {
      value: { code: "813319", label: "Other Social Advocacy Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Social Advocacy Organizations"
    },
    "813410": {
      value: { code: "813410", label: "Civic and Social Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Civic and Social Organizations"
    },
    "813910": {
      value: { code: "813910", label: "Business Associations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Business, Professional, Labor, Political, and Similar Organizations"
    },
    "813920": {
      value: { code: "813920", label: "Professional Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Business, Professional, Labor, Political, and Similar Organizations"
    },
    "813930": {
      value: {
        code: "813930",
        label: "Labor Unions and Similar Labor Organizations"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Business, Professional, Labor, Political, and Similar Organizations"
    },
    "813940": {
      value: { code: "813940", label: "Political Organizations" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Business, Professional, Labor, Political, and Similar Organizations"
    },
    "813990": {
      value: {
        code: "813990",
        label: "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)"
      },
      industry: "Other Services (except Public Administration)",
      subcategory: "Business, Professional, Labor, Political, and Similar Organizations"
    },
    "814110": {
      value: { code: "814110", label: "Private Households" },
      industry: "Other Services (except Public Administration)",
      subcategory: "Private Households"
    },
    "921110": {
      value: { code: "921110", label: "Executive Offices" },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "921120": {
      value: { code: "921120", label: "Legislative Bodies" },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "921130": {
      value: { code: "921130", label: "Public Finance Activities" },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "921140": {
      value: {
        code: "921140",
        label: "Executive and Legislative Offices, Combined"
      },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "921150": {
      value: {
        code: "921150",
        label: "American Indian and Alaska Native Tribal Governments"
      },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "921190": {
      value: { code: "921190", label: "Other General Government Support" },
      industry: "Public Administration",
      subcategory: "Executive, Legislative, and Other General Government Support"
    },
    "922110": {
      value: { code: "922110", label: "Courts" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922120": {
      value: { code: "922120", label: "Police Protection" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922130": {
      value: { code: "922130", label: "Legal Counsel and Prosecution" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922140": {
      value: { code: "922140", label: "Correctional Institutions" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922150": {
      value: { code: "922150", label: "Parole Offices and Probation Offices" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922160": {
      value: { code: "922160", label: "Fire Protection" },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "922190": {
      value: {
        code: "922190",
        label: "Other Justice, Public Order, and Safety Activities"
      },
      industry: "Public Administration",
      subcategory: "Justice, Public Order, and Safety Activities"
    },
    "923110": {
      value: { code: "923110", label: "Administration of Education Programs" },
      industry: "Public Administration",
      subcategory: "Administration of Human Resource Programs"
    },
    "923120": {
      value: {
        code: "923120",
        label: "Administration of Public Health Programs"
      },
      industry: "Public Administration",
      subcategory: "Administration of Human Resource Programs"
    },
    "923130": {
      value: {
        code: "923130",
        label: "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)"
      },
      industry: "Public Administration",
      subcategory: "Administration of Human Resource Programs"
    },
    "923140": {
      value: { code: "923140", label: "Administration of Veterans' Affairs" },
      industry: "Public Administration",
      subcategory: "Administration of Human Resource Programs"
    },
    "924110": {
      value: {
        code: "924110",
        label: "Administration of Air and Water Resource and Solid Waste Management Programs"
      },
      industry: "Public Administration",
      subcategory: "Administration of Environmental Quality Programs"
    },
    "924120": {
      value: {
        code: "924120",
        label: "Administration of Conservation Programs"
      },
      industry: "Public Administration",
      subcategory: "Administration of Environmental Quality Programs"
    },
    "925110": {
      value: { code: "925110", label: "Administration of Housing Programs" },
      industry: "Public Administration",
      subcategory: "Administration of Housing Programs, Urban Planning, and Community Development"
    },
    "925120": {
      value: {
        code: "925120",
        label: "Administration of Urban Planning and Community and Rural Development"
      },
      industry: "Public Administration",
      subcategory: "Administration of Housing Programs, Urban Planning, and Community Development"
    },
    "926110": {
      value: {
        code: "926110",
        label: "Administration of General Economic Programs"
      },
      industry: "Public Administration",
      subcategory: "Administration of Economic Programs"
    },
    "926120": {
      value: {
        code: "926120",
        label: "Regulation and Administration of Transportation Programs"
      },
      industry: "Public Administration",
      subcategory: "Administration of Economic Programs"
    },
    "926130": {
      value: {
        code: "926130",
        label: "Regulation and Administration of Communications, Electric, Gas, and Other Utilities"
      },
      industry: "Public Administration",
      subcategory: "Administration of Economic Programs"
    },
    "926140": {
      value: {
        code: "926140",
        label: "Regulation of Agricultural Marketing and Commodities"
      },
      industry: "Public Administration",
      subcategory: "Administration of Economic Programs"
    },
    "926150": {
      value: {
        code: "926150",
        label: "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors"
      },
      industry: "Public Administration",
      subcategory: "Administration of Economic Programs"
    },
    "927110": {
      value: { code: "927110", label: "Space Research and Technology" },
      industry: "Public Administration",
      subcategory: "Space Research and Technology"
    },
    "928110": {
      value: { code: "928110", label: "National Security" },
      industry: "Public Administration",
      subcategory: "National Security and International Affairs"
    },
    "928120": {
      value: { code: "928120", label: "International Affairs" },
      industry: "Public Administration",
      subcategory: "National Security and International Affairs"
    }
  }
  